/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as protectedIndexRouteImport } from './routes/(protected)/index'
import { Route as IntegrationsGithubAppCallbackRouteImport } from './routes/integrations/github-app-callback'
import { Route as DemoPulseRouteImport } from './routes/demo/pulse'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authSopShareVerifyOtpRouteImport } from './routes/(auth)/sop-share-verify-otp'
import { Route as authSopShareInviteRouteImport } from './routes/(auth)/sop-share-invite'
import { Route as authShareInviteRouteImport } from './routes/(auth)/share-invite'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authLogoutRouteImport } from './routes/(auth)/logout'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authInviteRouteImport } from './routes/(auth)/invite'
import { Route as authAcceptInvitationRouteImport } from './routes/(auth)/accept-invitation'
import { Route as protectedWorkspacesRouteRouteImport } from './routes/(protected)/workspaces/route'
import { Route as protectedSettingsRouteRouteImport } from './routes/(protected)/settings/route'
import { Route as protectedPartnerRouteRouteImport } from './routes/(protected)/partner/route'
import { Route as protectedOrgsRouteRouteImport } from './routes/(protected)/orgs/route'
import { Route as ExportTopicPdfIndexRouteImport } from './routes/export/topic-pdf/index'
import { Route as ExportTopicEmbedIndexRouteImport } from './routes/export/topic-embed/index'
import { Route as ExportSopPdfIndexRouteImport } from './routes/export/sop-pdf/index'
import { Route as ExportSopEmbedIndexRouteImport } from './routes/export/sop-embed/index'
import { Route as EvidenceVerifyIndexRouteImport } from './routes/evidence/verify/index'
import { Route as DemoTiptapIndexRouteImport } from './routes/demo/tiptap/index'
import { Route as protectedTasksIndexRouteImport } from './routes/(protected)/tasks/index'
import { Route as protectedSettingsIndexRouteImport } from './routes/(protected)/settings/index'
import { Route as protectedPartnerIndexRouteImport } from './routes/(protected)/partner/index'
import { Route as DemoTiptapAiSuggestionRouteImport } from './routes/demo/tiptap/ai-suggestion'
import { Route as DemoTiptapAiChangesRouteImport } from './routes/demo/tiptap/ai-changes'
import { Route as protectedWorkspacesNewRouteImport } from './routes/(protected)/workspaces/new'
import { Route as protectedSettingsWritingRouteImport } from './routes/(protected)/settings/writing'
import { Route as protectedSettingsThemeRouteImport } from './routes/(protected)/settings/theme'
import { Route as protectedSettingsTemplatesRouteImport } from './routes/(protected)/settings/templates'
import { Route as protectedSettingsSigningRouteImport } from './routes/(protected)/settings/signing'
import { Route as protectedSettingsSecurityRouteImport } from './routes/(protected)/settings/security'
import { Route as protectedSettingsReviewRouteImport } from './routes/(protected)/settings/review'
import { Route as protectedSettingsPublishingRouteImport } from './routes/(protected)/settings/publishing'
import { Route as protectedSettingsPropertiesRouteImport } from './routes/(protected)/settings/properties'
import { Route as protectedSettingsProfileRouteImport } from './routes/(protected)/settings/profile'
import { Route as protectedSettingsPersonasRouteImport } from './routes/(protected)/settings/personas'
import { Route as protectedSettingsOrganizationRouteImport } from './routes/(protected)/settings/organization'
import { Route as protectedSettingsMembersRouteImport } from './routes/(protected)/settings/members'
import { Route as protectedSettingsMcpServerRouteImport } from './routes/(protected)/settings/mcp-server'
import { Route as protectedSettingsGeneralRouteImport } from './routes/(protected)/settings/general'
import { Route as protectedSettingsConfigurationRouteImport } from './routes/(protected)/settings/configuration'
import { Route as protectedSettingsComplianceRouteImport } from './routes/(protected)/settings/compliance'
import { Route as protectedSettingsChecksRouteImport } from './routes/(protected)/settings/checks'
import { Route as protectedSettingsChatRouteImport } from './routes/(protected)/settings/chat'
import { Route as protectedSettingsBrandingRouteImport } from './routes/(protected)/settings/branding'
import { Route as protectedSettingsBillingRouteImport } from './routes/(protected)/settings/billing'
import { Route as protectedSettingsAuthRouteImport } from './routes/(protected)/settings/auth'
import { Route as protectedSettingsAuditLogsRouteImport } from './routes/(protected)/settings/audit-logs'
import { Route as protectedSettingsApiKeysRouteImport } from './routes/(protected)/settings/api-keys'
import { Route as protectedPartnerTemplatesRouteImport } from './routes/(protected)/partner/templates'
import { Route as protectedDevPlanRestrictionsTestRouteImport } from './routes/(protected)/dev/plan-restrictions-test'
import { Route as authNativeLoginRouteImport } from './routes/(auth)/native/login'
import { Route as authNativeAuthCallbackRouteImport } from './routes/(auth)/native/auth-callback'
import { Route as authAuthCallbackProviderRouteImport } from './routes/(auth)/auth-callback/$provider'
import { Route as protectedWorkspacesWorkspaceIdRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/route'
import { Route as protectedOrgsSlugRouteRouteImport } from './routes/(protected)/orgs/$slug/route'
import { Route as protectedWorkspacesWorkspaceIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/index'
import { Route as protectedWorkspaceIntegrationsIndexRouteImport } from './routes/(protected)/workspace/integrations/index'
import { Route as protectedSettingsServiceAccountsIndexRouteImport } from './routes/(protected)/settings/service-accounts/index'
import { Route as protectedWorkspacesWorkspaceIdVideoProcessingRouteImport } from './routes/(protected)/workspaces/$workspaceId/video-processing'
import { Route as protectedWorkspacesWorkspaceIdSummaryRouteImport } from './routes/(protected)/workspaces/$workspaceId/summary'
import { Route as protectedWorkspacesWorkspaceIdReviewTopicsRouteImport } from './routes/(protected)/workspaces/$workspaceId/review-topics'
import { Route as protectedWorkspacesWorkspaceIdEditRouteImport } from './routes/(protected)/workspaces/$workspaceId/edit'
import { Route as protectedWorkspacesWorkspaceIdAnalyticsRouteImport } from './routes/(protected)/workspaces/$workspaceId/analytics'
import { Route as protectedWorkspaceIntegrationsGithubRouteImport } from './routes/(protected)/workspace/integrations/github'
import { Route as protectedPartnerClientsNewRouteImport } from './routes/(protected)/partner/clients/new'
import { Route as protectedPartnerClientsClientIdRouteImport } from './routes/(protected)/partner/clients/$clientId'
import { Route as protectedWorkspacesWorkspaceIdPublishRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/publish/route'
import { Route as protectedWorkspacesWorkspaceIdImportRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/import/route'
import { Route as protectedWorkspacesWorkspaceIdDocsRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/docs/route'
import { Route as protectedWorkspacesWorkspaceIdComplianceRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/route'
import { Route as protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/index'
import { Route as protectedWorkspacesWorkspaceIdTasksIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/tasks/index'
import { Route as protectedWorkspacesWorkspaceIdSourcesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/sources/index'
import { Route as protectedWorkspacesWorkspaceIdSopsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/index'
import { Route as protectedWorkspacesWorkspaceIdScreenataIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/index'
import { Route as protectedWorkspacesWorkspaceIdPulseIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/pulse/index'
import { Route as protectedWorkspacesWorkspaceIdPublishIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/publish/index'
import { Route as protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/knowledge-gaps/index'
import { Route as protectedWorkspacesWorkspaceIdGlossaryIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/glossary/index'
import { Route as protectedWorkspacesWorkspaceIdEvidenceIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence/index'
import { Route as protectedWorkspacesWorkspaceIdDashboardIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/dashboard/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/index'
import { Route as protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/public'
import { Route as protectedWorkspacesWorkspaceIdTemplatesNewRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/new'
import { Route as protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/tasks/$taskId'
import { Route as protectedWorkspacesWorkspaceIdScreenataTestsRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/tests'
import { Route as protectedWorkspacesWorkspaceIdScreenataTestOutlineRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/test-outline'
import { Route as protectedWorkspacesWorkspaceIdScreenataScopeConfirmRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/scope-confirm'
import { Route as protectedWorkspacesWorkspaceIdScreenataReadinessRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/readiness'
import { Route as protectedWorkspacesWorkspaceIdScreenataPoliciesRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/policies'
import { Route as protectedWorkspacesWorkspaceIdScreenataIntegrationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/integrations'
import { Route as protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/generate-policies'
import { Route as protectedWorkspacesWorkspaceIdScreenataEvidenceRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/evidence'
import { Route as protectedWorkspacesWorkspaceIdScreenataConnectRepoRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/connect-repo'
import { Route as protectedWorkspacesWorkspaceIdScreenataApprovalsRouteImport } from './routes/(protected)/workspaces/$workspaceId/screenata/approvals'
import { Route as protectedWorkspacesWorkspaceIdPulseConfigureRouteImport } from './routes/(protected)/workspaces/$workspaceId/pulse/configure'
import { Route as protectedWorkspacesWorkspaceIdPublishFilesRouteImport } from './routes/(protected)/workspaces/$workspaceId/publish/files'
import { Route as protectedWorkspacesWorkspaceIdGenerateDocRouteImport } from './routes/(protected)/workspaces/$workspaceId/generate/doc'
import { Route as protectedWorkspacesWorkspaceIdEvidenceWorkQueueRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence/work-queue'
import { Route as protectedWorkspacesWorkspaceIdEvidenceReviewQueueRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence/review-queue'
import { Route as protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence/creating'
import { Route as protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence/$evidenceId'
import { Route as protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
import { Route as protectedWorkspacesWorkspaceIdDocsSplatRouteImport } from './routes/(protected)/workspaces/$workspaceId/docs/$'
import { Route as protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/$templateId/index'
import { Route as protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/steps/$id/index'
import { Route as protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/$sopId/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceTasksIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/tasks/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceSetupIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/setup/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceRunsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/runs/index'
import { Route as protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/populations/index'
import { Route as protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/policies/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/$frameworkId/index'
import { Route as protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
import { Route as protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
import { Route as protectedWorkspacesWorkspaceIdComplianceTestsTestIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/tests/$testId'
import { Route as protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/submissions/$submissionId'
import { Route as protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/runs/$executionId'
import { Route as protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/control/$controlId/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/automation/$executionId/index'
import { Route as protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/compliance/$frameworkId/controls/index'
import { Route as protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'

const ExtensionUninstalledLazyRouteImport = createFileRoute(
  '/extension-uninstalled',
)()
const SharedShareIdLazyRouteImport = createFileRoute('/shared/$shareId')()
const SharedSopShareIdLazyRouteImport = createFileRoute(
  '/shared-sop/$shareId',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authVerifyOtpLazyRouteImport = createFileRoute('/(auth)/verify-otp')()
const authVerify2faLazyRouteImport = createFileRoute('/(auth)/verify-2fa')()
const authSignupLazyRouteImport = createFileRoute('/(auth)/signup')()
const authLogin2LazyRouteImport = createFileRoute('/(auth)/login-2')()
const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const protectedWorkspacesIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/',
)()
const protectedTeamIndexLazyRouteImport =
  createFileRoute('/(protected)/team/')()
const protectedOrgsIndexLazyRouteImport =
  createFileRoute('/(protected)/orgs/')()
const protectedOnboardingIndexLazyRouteImport = createFileRoute(
  '/(protected)/onboarding/',
)()
const protectedIntegrationsIndexLazyRouteImport = createFileRoute(
  '/(protected)/integrations/',
)()
const SharedTestShareTokenLazyRouteImport = createFileRoute(
  '/shared/test/$shareToken',
)()
const protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/git-settings')()
const protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/agent-reliability')()
const protectedOnboardingOrganizationIdWorkspaceLazyRouteImport =
  createFileRoute('/(protected)/onboarding/$organizationId/workspace')()
const protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/$workspaceId/steps/',
)()
const protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/integrations/')()
const protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/$workspaceId/flows/',
)()
const protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/change-requests/')()
const protectedWorkspacesWorkspaceIdBranchesIndexLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/branches/')()
const protectedWorkspacesWorkspaceIdPublishStageLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/publish/stage')()
const protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/publish/deployments')()
const protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/compliance/automation/',
  )()
const protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/',
  )()
const protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/flows/$flowId/view')()
const protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/compliance/automation/identities',
  )()

const ExtensionUninstalledLazyRoute =
  ExtensionUninstalledLazyRouteImport.update({
    id: '/extension-uninstalled',
    path: '/extension-uninstalled',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/extension-uninstalled.lazy').then((d) => d.Route),
  )
const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedIndexRoute = protectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const SharedShareIdLazyRoute = SharedShareIdLazyRouteImport.update({
  id: '/shared/$shareId',
  path: '/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared.$shareId.lazy').then((d) => d.Route),
)
const SharedSopShareIdLazyRoute = SharedSopShareIdLazyRouteImport.update({
  id: '/shared-sop/$shareId',
  path: '/shared-sop/$shareId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared-sop.$shareId.lazy').then((d) => d.Route),
)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authVerifyOtpLazyRoute = authVerifyOtpLazyRouteImport
  .update({
    id: '/verify-otp',
    path: '/verify-otp',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-otp.lazy').then((d) => d.Route))
const authVerify2faLazyRoute = authVerify2faLazyRouteImport
  .update({
    id: '/verify-2fa',
    path: '/verify-2fa',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-2fa.lazy').then((d) => d.Route))
const authSignupLazyRoute = authSignupLazyRouteImport
  .update({
    id: '/signup',
    path: '/signup',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/signup.lazy').then((d) => d.Route))
const authLogin2LazyRoute = authLogin2LazyRouteImport
  .update({
    id: '/login-2',
    path: '/login-2',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/login-2.lazy').then((d) => d.Route))
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const IntegrationsGithubAppCallbackRoute =
  IntegrationsGithubAppCallbackRouteImport.update({
    id: '/integrations/github-app-callback',
    path: '/integrations/github-app-callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoPulseRoute = DemoPulseRouteImport.update({
  id: '/demo/pulse',
  path: '/demo/pulse',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport
  .update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-email.lazy').then((d) => d.Route))
const authSopShareVerifyOtpRoute = authSopShareVerifyOtpRouteImport.update({
  id: '/sop-share-verify-otp',
  path: '/sop-share-verify-otp',
  getParentRoute: () => authRouteRoute,
} as any)
const authSopShareInviteRoute = authSopShareInviteRouteImport.update({
  id: '/sop-share-invite',
  path: '/sop-share-invite',
  getParentRoute: () => authRouteRoute,
} as any)
const authShareInviteRoute = authShareInviteRouteImport.update({
  id: '/share-invite',
  path: '/share-invite',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => authRouteRoute,
} as any)
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authInviteRoute = authInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => authRouteRoute,
} as any)
const authAcceptInvitationRoute = authAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedWorkspacesRouteRoute =
  protectedWorkspacesRouteRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsRouteRoute = protectedSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedPartnerRouteRoute = protectedPartnerRouteRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedOrgsRouteRoute = protectedOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedWorkspacesIndexLazyRoute =
  protectedWorkspacesIndexLazyRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => protectedWorkspacesRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/index.lazy').then((d) => d.Route),
    )
const protectedTeamIndexLazyRoute = protectedTeamIndexLazyRouteImport
  .update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(protected)/team/index.lazy').then((d) => d.Route),
  )
const protectedOrgsIndexLazyRoute = protectedOrgsIndexLazyRouteImport
  .update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedOrgsRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(protected)/orgs/index.lazy').then((d) => d.Route),
  )
const protectedOnboardingIndexLazyRoute =
  protectedOnboardingIndexLazyRouteImport
    .update({
      id: '/onboarding/',
      path: '/onboarding/',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/index.lazy').then((d) => d.Route),
    )
const protectedIntegrationsIndexLazyRoute =
  protectedIntegrationsIndexLazyRouteImport
    .update({
      id: '/integrations/',
      path: '/integrations/',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/integrations/index.lazy').then(
        (d) => d.Route,
      ),
    )
const ExportTopicPdfIndexRoute = ExportTopicPdfIndexRouteImport.update({
  id: '/export/topic-pdf/',
  path: '/export/topic-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportTopicEmbedIndexRoute = ExportTopicEmbedIndexRouteImport.update({
  id: '/export/topic-embed/',
  path: '/export/topic-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportSopPdfIndexRoute = ExportSopPdfIndexRouteImport.update({
  id: '/export/sop-pdf/',
  path: '/export/sop-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportSopEmbedIndexRoute = ExportSopEmbedIndexRouteImport.update({
  id: '/export/sop-embed/',
  path: '/export/sop-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvidenceVerifyIndexRoute = EvidenceVerifyIndexRouteImport.update({
  id: '/evidence/verify/',
  path: '/evidence/verify/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapIndexRoute = DemoTiptapIndexRouteImport.update({
  id: '/demo/tiptap/',
  path: '/demo/tiptap/',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedTasksIndexRoute = protectedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSettingsIndexRoute = protectedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedPartnerIndexRoute = protectedPartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedPartnerRouteRoute,
} as any)
const SharedTestShareTokenLazyRoute =
  SharedTestShareTokenLazyRouteImport.update({
    id: '/shared/test/$shareToken',
    path: '/shared/test/$shareToken',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/shared.test.$shareToken.lazy').then((d) => d.Route),
  )
const DemoTiptapAiSuggestionRoute = DemoTiptapAiSuggestionRouteImport.update({
  id: '/demo/tiptap/ai-suggestion',
  path: '/demo/tiptap/ai-suggestion',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapAiChangesRoute = DemoTiptapAiChangesRouteImport.update({
  id: '/demo/tiptap/ai-changes',
  path: '/demo/tiptap/ai-changes',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedWorkspacesNewRoute = protectedWorkspacesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => protectedWorkspacesRouteRoute,
} as any)
const protectedSettingsWritingRoute =
  protectedSettingsWritingRouteImport.update({
    id: '/writing',
    path: '/writing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsThemeRoute = protectedSettingsThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsTemplatesRoute =
  protectedSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSigningRoute =
  protectedSettingsSigningRouteImport.update({
    id: '/signing',
    path: '/signing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSecurityRoute =
  protectedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsReviewRoute = protectedSettingsReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsPublishingRoute =
  protectedSettingsPublishingRouteImport.update({
    id: '/publishing',
    path: '/publishing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsPropertiesRoute =
  protectedSettingsPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsProfileRoute =
  protectedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsPersonasRoute =
  protectedSettingsPersonasRouteImport.update({
    id: '/personas',
    path: '/personas',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsOrganizationRoute =
  protectedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsMembersRoute =
  protectedSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsMcpServerRoute =
  protectedSettingsMcpServerRouteImport.update({
    id: '/mcp-server',
    path: '/mcp-server',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsGeneralRoute =
  protectedSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsConfigurationRoute =
  protectedSettingsConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsComplianceRoute =
  protectedSettingsComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsChecksRoute = protectedSettingsChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsChatRoute = protectedSettingsChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsBrandingRoute =
  protectedSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsBillingRoute =
  protectedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsAuthRoute = protectedSettingsAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsAuditLogsRoute =
  protectedSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsApiKeysRoute =
  protectedSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedPartnerTemplatesRoute =
  protectedPartnerTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedDevPlanRestrictionsTestRoute =
  protectedDevPlanRestrictionsTestRouteImport.update({
    id: '/dev/plan-restrictions-test',
    path: '/dev/plan-restrictions-test',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const authNativeLoginRoute = authNativeLoginRouteImport.update({
  id: '/native/login',
  path: '/native/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authNativeAuthCallbackRoute = authNativeAuthCallbackRouteImport.update({
  id: '/native/auth-callback',
  path: '/native/auth-callback',
  getParentRoute: () => authRouteRoute,
} as any)
const authAuthCallbackProviderRoute =
  authAuthCallbackProviderRouteImport.update({
    id: '/auth-callback/$provider',
    path: '/auth-callback/$provider',
    getParentRoute: () => authRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRouteRoute =
  protectedWorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => protectedWorkspacesRouteRoute,
  } as any)
const protectedOrgsSlugRouteRoute = protectedOrgsSlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => protectedOrgsRouteRoute,
} as any)
const protectedWorkspacesWorkspaceIdIndexRoute =
  protectedWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspaceIntegrationsIndexRoute =
  protectedWorkspaceIntegrationsIndexRouteImport.update({
    id: '/workspace/integrations/',
    path: '/workspace/integrations/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsServiceAccountsIndexRoute =
  protectedSettingsServiceAccountsIndexRouteImport.update({
    id: '/service-accounts/',
    path: '/service-accounts/',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdGitSettingsLazyRoute =
  protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport
    .update({
      id: '/git-settings',
      path: '/git-settings',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/git-settings.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute =
  protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport
    .update({
      id: '/agent-reliability',
      path: '/agent-reliability',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/agent-reliability.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedOnboardingOrganizationIdWorkspaceLazyRoute =
  protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
    .update({
      id: '/onboarding/$organizationId/workspace',
      path: '/onboarding/$organizationId/workspace',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/$organizationId.workspace.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdVideoProcessingRoute =
  protectedWorkspacesWorkspaceIdVideoProcessingRouteImport.update({
    id: '/video-processing',
    path: '/video-processing',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSummaryRoute =
  protectedWorkspacesWorkspaceIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdReviewTopicsRoute =
  protectedWorkspacesWorkspaceIdReviewTopicsRouteImport.update({
    id: '/review-topics',
    path: '/review-topics',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEditRoute =
  protectedWorkspacesWorkspaceIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAnalyticsRoute =
  protectedWorkspacesWorkspaceIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspaceIntegrationsGithubRoute =
  protectedWorkspaceIntegrationsGithubRouteImport.update({
    id: '/workspace/integrations/github',
    path: '/workspace/integrations/github',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedPartnerClientsNewRoute =
  protectedPartnerClientsNewRouteImport.update({
    id: '/clients/new',
    path: '/clients/new',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedPartnerClientsClientIdRoute =
  protectedPartnerClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPublishRouteRoute =
  protectedWorkspacesWorkspaceIdPublishRouteRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdImportRouteRoute =
  protectedWorkspacesWorkspaceIdImportRouteRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDocsRouteRoute =
  protectedWorkspacesWorkspaceIdDocsRouteRouteImport.update({
    id: '/docs',
    path: '/docs',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceRouteRoute =
  protectedWorkspacesWorkspaceIdComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdStepsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport
    .update({
      id: '/steps/',
      path: '/steps/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/steps/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport
    .update({
      id: '/integrations/',
      path: '/integrations/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/integrations/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport
    .update({
      id: '/flows/',
      path: '/flows/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/flows/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRouteImport
    .update({
      id: '/change-requests/',
      path: '/change-requests/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/change-requests/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute =
  protectedWorkspacesWorkspaceIdBranchesIndexLazyRouteImport
    .update({
      id: '/branches/',
      path: '/branches/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/branches/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTemplatesIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTasksIndexRoute =
  protectedWorkspacesWorkspaceIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSourcesIndexRoute =
  protectedWorkspacesWorkspaceIdSourcesIndexRouteImport.update({
    id: '/sources/',
    path: '/sources/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSopsIndexRoute =
  protectedWorkspacesWorkspaceIdSopsIndexRouteImport.update({
    id: '/sops/',
    path: '/sops/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataIndexRoute =
  protectedWorkspacesWorkspaceIdScreenataIndexRouteImport.update({
    id: '/screenata/',
    path: '/screenata/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPulseIndexRoute =
  protectedWorkspacesWorkspaceIdPulseIndexRouteImport.update({
    id: '/pulse/',
    path: '/pulse/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPublishIndexRoute =
  protectedWorkspacesWorkspaceIdPublishIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdPublishRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute =
  protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRouteImport.update({
    id: '/knowledge-gaps/',
    path: '/knowledge-gaps/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdGlossaryIndexRoute =
  protectedWorkspacesWorkspaceIdGlossaryIndexRouteImport.update({
    id: '/glossary/',
    path: '/glossary/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceIndexRoute =
  protectedWorkspacesWorkspaceIdEvidenceIndexRouteImport.update({
    id: '/evidence/',
    path: '/evidence/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDashboardIndexRoute =
  protectedWorkspacesWorkspaceIdDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPublishStageLazyRoute =
  protectedWorkspacesWorkspaceIdPublishStageLazyRouteImport
    .update({
      id: '/stage',
      path: '/stage',
      getParentRoute: () => protectedWorkspacesWorkspaceIdPublishRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/publish/stage.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute =
  protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRouteImport
    .update({
      id: '/deployments',
      path: '/deployments',
      getParentRoute: () => protectedWorkspacesWorkspaceIdPublishRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/publish/deployments.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTemplatesPublicRoute =
  protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport.update({
    id: '/templates/public',
    path: '/templates/public',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesNewRoute =
  protectedWorkspacesWorkspaceIdTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTasksTaskIdRoute =
  protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataTestsRoute =
  protectedWorkspacesWorkspaceIdScreenataTestsRouteImport.update({
    id: '/screenata/tests',
    path: '/screenata/tests',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute =
  protectedWorkspacesWorkspaceIdScreenataTestOutlineRouteImport.update({
    id: '/screenata/test-outline',
    path: '/screenata/test-outline',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute =
  protectedWorkspacesWorkspaceIdScreenataScopeConfirmRouteImport.update({
    id: '/screenata/scope-confirm',
    path: '/screenata/scope-confirm',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataReadinessRoute =
  protectedWorkspacesWorkspaceIdScreenataReadinessRouteImport.update({
    id: '/screenata/readiness',
    path: '/screenata/readiness',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataPoliciesRoute =
  protectedWorkspacesWorkspaceIdScreenataPoliciesRouteImport.update({
    id: '/screenata/policies',
    path: '/screenata/policies',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute =
  protectedWorkspacesWorkspaceIdScreenataIntegrationsRouteImport.update({
    id: '/screenata/integrations',
    path: '/screenata/integrations',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute =
  protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRouteImport.update({
    id: '/screenata/generate-policies',
    path: '/screenata/generate-policies',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataEvidenceRoute =
  protectedWorkspacesWorkspaceIdScreenataEvidenceRouteImport.update({
    id: '/screenata/evidence',
    path: '/screenata/evidence',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute =
  protectedWorkspacesWorkspaceIdScreenataConnectRepoRouteImport.update({
    id: '/screenata/connect-repo',
    path: '/screenata/connect-repo',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdScreenataApprovalsRoute =
  protectedWorkspacesWorkspaceIdScreenataApprovalsRouteImport.update({
    id: '/screenata/approvals',
    path: '/screenata/approvals',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPulseConfigureRoute =
  protectedWorkspacesWorkspaceIdPulseConfigureRouteImport.update({
    id: '/pulse/configure',
    path: '/pulse/configure',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPublishFilesRoute =
  protectedWorkspacesWorkspaceIdPublishFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => protectedWorkspacesWorkspaceIdPublishRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdGenerateDocRoute =
  protectedWorkspacesWorkspaceIdGenerateDocRouteImport.update({
    id: '/generate/doc',
    path: '/generate/doc',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute =
  protectedWorkspacesWorkspaceIdEvidenceWorkQueueRouteImport.update({
    id: '/evidence/work-queue',
    path: '/evidence/work-queue',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute =
  protectedWorkspacesWorkspaceIdEvidenceReviewQueueRouteImport.update({
    id: '/evidence/review-queue',
    path: '/evidence/review-queue',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceCreatingRoute =
  protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport.update({
    id: '/evidence/creating',
    path: '/evidence/creating',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute =
  protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRouteImport.update({
    id: '/evidence/$evidenceId',
    path: '/evidence/$evidenceId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute =
  protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport.update({
    id: '/evidence-viewer/$evidencePackId',
    path: '/evidence-viewer/$evidencePackId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDocsSplatRoute =
  protectedWorkspacesWorkspaceIdDocsSplatRouteImport
    .update({
      id: '/$',
      path: '/$',
      getParentRoute: () => protectedWorkspacesWorkspaceIdDocsRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/docs/$.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute =
  protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRouteImport
    .update({
      id: '/automation/',
      path: '/automation/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/compliance/automation/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute =
  protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRouteImport
    .update({
      id: '/change-requests/$changeRequestId/',
      path: '/change-requests/$changeRequestId/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport.update({
    id: '/templates/$templateId/',
    path: '/templates/$templateId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdStepsIdIndexRoute =
  protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport.update({
    id: '/steps/$id/',
    path: '/steps/$id/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute =
  protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport.update({
    id: '/sops/$sopId/',
    path: '/sops/$sopId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute =
  protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRouteImport.update({
    id: '/populations/',
    path: '/populations/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute =
  protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRouteImport.update({
    id: '/$frameworkId/',
    path: '/$frameworkId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute =
  protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport
    .update({
      id: '/flows/$flowId/view',
      path: '/flows/$flowId/view',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/flows/$flowId/view.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute =
  protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRouteImport
    .update({
      id: '/automation/identities',
      path: '/automation/identities',
      getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/compliance/automation/identities.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute =
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport.update({
    id: '/templates/$templateId/edit',
    path: '/templates/$templateId/edit',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute =
  protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport.update({
    id: '/sops/$sopId/generate',
    path: '/sops/$sopId/generate',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute =
  protectedWorkspacesWorkspaceIdComplianceTestsTestIdRouteImport.update({
    id: '/tests/$testId',
    path: '/tests/$testId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute =
  protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRouteImport.update(
    {
      id: '/submissions/$submissionId',
      path: '/submissions/$submissionId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute =
  protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRouteImport.update({
    id: '/runs/$executionId',
    path: '/runs/$executionId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport.update(
    {
      id: '/templates/control/$controlId/',
      path: '/templates/control/$controlId/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRouteImport.update(
    {
      id: '/automation/$executionId/',
      path: '/automation/$executionId/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute =
  protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRouteImport.update(
    {
      id: '/$frameworkId/controls/',
      path: '/$frameworkId/controls/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdComplianceRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute =
  protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRouteImport.update(
    {
      id: '/workflows/$workflowId/executions/$jobId',
      path: '/workflows/$workflowId/executions/$jobId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/partner': typeof protectedPartnerRouteRouteWithChildren
  '/settings': typeof protectedSettingsRouteRouteWithChildren
  '/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/invite': typeof authInviteRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/share-invite': typeof authShareInviteRoute
  '/sop-share-invite': typeof authSopShareInviteRoute
  '/sop-share-verify-otp': typeof authSopShareVerifyOtpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/partner/templates': typeof protectedPartnerTemplatesRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/settings/auth': typeof protectedSettingsAuthRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/branding': typeof protectedSettingsBrandingRoute
  '/settings/chat': typeof protectedSettingsChatRoute
  '/settings/checks': typeof protectedSettingsChecksRoute
  '/settings/compliance': typeof protectedSettingsComplianceRoute
  '/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/settings/general': typeof protectedSettingsGeneralRoute
  '/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/settings/members': typeof protectedSettingsMembersRoute
  '/settings/organization': typeof protectedSettingsOrganizationRoute
  '/settings/personas': typeof protectedSettingsPersonasRoute
  '/settings/profile': typeof protectedSettingsProfileRoute
  '/settings/properties': typeof protectedSettingsPropertiesRoute
  '/settings/publishing': typeof protectedSettingsPublishingRoute
  '/settings/review': typeof protectedSettingsReviewRoute
  '/settings/security': typeof protectedSettingsSecurityRoute
  '/settings/signing': typeof protectedSettingsSigningRoute
  '/settings/templates': typeof protectedSettingsTemplatesRoute
  '/settings/theme': typeof protectedSettingsThemeRoute
  '/settings/writing': typeof protectedSettingsWritingRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/shared/test/$shareToken': typeof SharedTestShareTokenLazyRoute
  '/partner/': typeof protectedPartnerIndexRoute
  '/settings/': typeof protectedSettingsIndexRoute
  '/tasks/': typeof protectedTasksIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/evidence/verify/': typeof EvidenceVerifyIndexRoute
  '/export/sop-embed/': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf/': typeof ExportSopPdfIndexRoute
  '/export/topic-embed/': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf/': typeof ExportTopicPdfIndexRoute
  '/integrations/': typeof protectedIntegrationsIndexLazyRoute
  '/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/orgs/': typeof protectedOrgsIndexLazyRoute
  '/team/': typeof protectedTeamIndexLazyRoute
  '/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/workspaces/$workspaceId/compliance': typeof protectedWorkspacesWorkspaceIdComplianceRouteRouteWithChildren
  '/workspaces/$workspaceId/docs': typeof protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren
  '/workspaces/$workspaceId/import': typeof protectedWorkspacesWorkspaceIdImportRouteRoute
  '/workspaces/$workspaceId/publish': typeof protectedWorkspacesWorkspaceIdPublishRouteRouteWithChildren
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/workspaces/$workspaceId/review-topics': typeof protectedWorkspacesWorkspaceIdReviewTopicsRoute
  '/workspaces/$workspaceId/summary': typeof protectedWorkspacesWorkspaceIdSummaryRoute
  '/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/settings/service-accounts/': typeof protectedSettingsServiceAccountsIndexRoute
  '/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/docs/$': typeof protectedWorkspacesWorkspaceIdDocsSplatRoute
  '/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/workspaces/$workspaceId/evidence/$evidenceId': typeof protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute
  '/workspaces/$workspaceId/evidence/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/workspaces/$workspaceId/evidence/review-queue': typeof protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute
  '/workspaces/$workspaceId/evidence/work-queue': typeof protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute
  '/workspaces/$workspaceId/generate/doc': typeof protectedWorkspacesWorkspaceIdGenerateDocRoute
  '/workspaces/$workspaceId/publish/files': typeof protectedWorkspacesWorkspaceIdPublishFilesRoute
  '/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/workspaces/$workspaceId/screenata/approvals': typeof protectedWorkspacesWorkspaceIdScreenataApprovalsRoute
  '/workspaces/$workspaceId/screenata/connect-repo': typeof protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute
  '/workspaces/$workspaceId/screenata/evidence': typeof protectedWorkspacesWorkspaceIdScreenataEvidenceRoute
  '/workspaces/$workspaceId/screenata/generate-policies': typeof protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute
  '/workspaces/$workspaceId/screenata/integrations': typeof protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute
  '/workspaces/$workspaceId/screenata/policies': typeof protectedWorkspacesWorkspaceIdScreenataPoliciesRoute
  '/workspaces/$workspaceId/screenata/readiness': typeof protectedWorkspacesWorkspaceIdScreenataReadinessRoute
  '/workspaces/$workspaceId/screenata/scope-confirm': typeof protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute
  '/workspaces/$workspaceId/screenata/test-outline': typeof protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute
  '/workspaces/$workspaceId/screenata/tests': typeof protectedWorkspacesWorkspaceIdScreenataTestsRoute
  '/workspaces/$workspaceId/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/workspaces/$workspaceId/publish/deployments': typeof protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute
  '/workspaces/$workspaceId/publish/stage': typeof protectedWorkspacesWorkspaceIdPublishStageLazyRoute
  '/workspaces/$workspaceId/compliance/': typeof protectedWorkspacesWorkspaceIdComplianceIndexRoute
  '/workspaces/$workspaceId/dashboard/': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/workspaces/$workspaceId/evidence/': typeof protectedWorkspacesWorkspaceIdEvidenceIndexRoute
  '/workspaces/$workspaceId/glossary/': typeof protectedWorkspacesWorkspaceIdGlossaryIndexRoute
  '/workspaces/$workspaceId/knowledge-gaps/': typeof protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute
  '/workspaces/$workspaceId/publish/': typeof protectedWorkspacesWorkspaceIdPublishIndexRoute
  '/workspaces/$workspaceId/pulse/': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/workspaces/$workspaceId/screenata/': typeof protectedWorkspacesWorkspaceIdScreenataIndexRoute
  '/workspaces/$workspaceId/sops/': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/workspaces/$workspaceId/sources/': typeof protectedWorkspacesWorkspaceIdSourcesIndexRoute
  '/workspaces/$workspaceId/tasks/': typeof protectedWorkspacesWorkspaceIdTasksIndexRoute
  '/workspaces/$workspaceId/templates/': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/workspaces/$workspaceId/branches/': typeof protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute
  '/workspaces/$workspaceId/change-requests/': typeof protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute
  '/workspaces/$workspaceId/flows/': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/workspaces/$workspaceId/integrations/': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/workspaces/$workspaceId/steps/': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/workspaces/$workspaceId/compliance/runs/$executionId': typeof protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute
  '/workspaces/$workspaceId/compliance/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute
  '/workspaces/$workspaceId/compliance/tests/$testId': typeof protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute
  '/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/workspaces/$workspaceId/compliance/automation/identities': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute
  '/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/workspaces/$workspaceId/compliance/$frameworkId/': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute
  '/workspaces/$workspaceId/compliance/policies/': typeof protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute
  '/workspaces/$workspaceId/compliance/populations/': typeof protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute
  '/workspaces/$workspaceId/compliance/runs/': typeof protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute
  '/workspaces/$workspaceId/compliance/setup/': typeof protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute
  '/workspaces/$workspaceId/compliance/tasks/': typeof protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute
  '/workspaces/$workspaceId/sops/$sopId/': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/workspaces/$workspaceId/steps/$id/': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
  '/workspaces/$workspaceId/templates/$templateId/': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/workspaces/$workspaceId/change-requests/$changeRequestId/': typeof protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute
  '/workspaces/$workspaceId/compliance/automation/': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute
  '/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute
  '/workspaces/$workspaceId/compliance/$frameworkId/controls/': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute
  '/workspaces/$workspaceId/compliance/automation/$executionId/': typeof protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute
  '/workspaces/$workspaceId/templates/control/$controlId/': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
}
export interface FileRoutesByTo {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/invite': typeof authInviteRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/share-invite': typeof authShareInviteRoute
  '/sop-share-invite': typeof authSopShareInviteRoute
  '/sop-share-verify-otp': typeof authSopShareVerifyOtpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/partner/templates': typeof protectedPartnerTemplatesRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/settings/auth': typeof protectedSettingsAuthRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/branding': typeof protectedSettingsBrandingRoute
  '/settings/chat': typeof protectedSettingsChatRoute
  '/settings/checks': typeof protectedSettingsChecksRoute
  '/settings/compliance': typeof protectedSettingsComplianceRoute
  '/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/settings/general': typeof protectedSettingsGeneralRoute
  '/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/settings/members': typeof protectedSettingsMembersRoute
  '/settings/organization': typeof protectedSettingsOrganizationRoute
  '/settings/personas': typeof protectedSettingsPersonasRoute
  '/settings/profile': typeof protectedSettingsProfileRoute
  '/settings/properties': typeof protectedSettingsPropertiesRoute
  '/settings/publishing': typeof protectedSettingsPublishingRoute
  '/settings/review': typeof protectedSettingsReviewRoute
  '/settings/security': typeof protectedSettingsSecurityRoute
  '/settings/signing': typeof protectedSettingsSigningRoute
  '/settings/templates': typeof protectedSettingsTemplatesRoute
  '/settings/theme': typeof protectedSettingsThemeRoute
  '/settings/writing': typeof protectedSettingsWritingRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/shared/test/$shareToken': typeof SharedTestShareTokenLazyRoute
  '/partner': typeof protectedPartnerIndexRoute
  '/settings': typeof protectedSettingsIndexRoute
  '/tasks': typeof protectedTasksIndexRoute
  '/demo/tiptap': typeof DemoTiptapIndexRoute
  '/evidence/verify': typeof EvidenceVerifyIndexRoute
  '/export/sop-embed': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf': typeof ExportSopPdfIndexRoute
  '/export/topic-embed': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf': typeof ExportTopicPdfIndexRoute
  '/integrations': typeof protectedIntegrationsIndexLazyRoute
  '/onboarding': typeof protectedOnboardingIndexLazyRoute
  '/orgs': typeof protectedOrgsIndexLazyRoute
  '/team': typeof protectedTeamIndexLazyRoute
  '/workspaces': typeof protectedWorkspacesIndexLazyRoute
  '/workspaces/$workspaceId/docs': typeof protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren
  '/workspaces/$workspaceId/import': typeof protectedWorkspacesWorkspaceIdImportRouteRoute
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/workspaces/$workspaceId/review-topics': typeof protectedWorkspacesWorkspaceIdReviewTopicsRoute
  '/workspaces/$workspaceId/summary': typeof protectedWorkspacesWorkspaceIdSummaryRoute
  '/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/settings/service-accounts': typeof protectedSettingsServiceAccountsIndexRoute
  '/workspace/integrations': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/docs/$': typeof protectedWorkspacesWorkspaceIdDocsSplatRoute
  '/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/workspaces/$workspaceId/evidence/$evidenceId': typeof protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute
  '/workspaces/$workspaceId/evidence/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/workspaces/$workspaceId/evidence/review-queue': typeof protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute
  '/workspaces/$workspaceId/evidence/work-queue': typeof protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute
  '/workspaces/$workspaceId/generate/doc': typeof protectedWorkspacesWorkspaceIdGenerateDocRoute
  '/workspaces/$workspaceId/publish/files': typeof protectedWorkspacesWorkspaceIdPublishFilesRoute
  '/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/workspaces/$workspaceId/screenata/approvals': typeof protectedWorkspacesWorkspaceIdScreenataApprovalsRoute
  '/workspaces/$workspaceId/screenata/connect-repo': typeof protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute
  '/workspaces/$workspaceId/screenata/evidence': typeof protectedWorkspacesWorkspaceIdScreenataEvidenceRoute
  '/workspaces/$workspaceId/screenata/generate-policies': typeof protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute
  '/workspaces/$workspaceId/screenata/integrations': typeof protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute
  '/workspaces/$workspaceId/screenata/policies': typeof protectedWorkspacesWorkspaceIdScreenataPoliciesRoute
  '/workspaces/$workspaceId/screenata/readiness': typeof protectedWorkspacesWorkspaceIdScreenataReadinessRoute
  '/workspaces/$workspaceId/screenata/scope-confirm': typeof protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute
  '/workspaces/$workspaceId/screenata/test-outline': typeof protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute
  '/workspaces/$workspaceId/screenata/tests': typeof protectedWorkspacesWorkspaceIdScreenataTestsRoute
  '/workspaces/$workspaceId/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/workspaces/$workspaceId/publish/deployments': typeof protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute
  '/workspaces/$workspaceId/publish/stage': typeof protectedWorkspacesWorkspaceIdPublishStageLazyRoute
  '/workspaces/$workspaceId/compliance': typeof protectedWorkspacesWorkspaceIdComplianceIndexRoute
  '/workspaces/$workspaceId/dashboard': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/workspaces/$workspaceId/evidence': typeof protectedWorkspacesWorkspaceIdEvidenceIndexRoute
  '/workspaces/$workspaceId/glossary': typeof protectedWorkspacesWorkspaceIdGlossaryIndexRoute
  '/workspaces/$workspaceId/knowledge-gaps': typeof protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute
  '/workspaces/$workspaceId/publish': typeof protectedWorkspacesWorkspaceIdPublishIndexRoute
  '/workspaces/$workspaceId/pulse': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/workspaces/$workspaceId/screenata': typeof protectedWorkspacesWorkspaceIdScreenataIndexRoute
  '/workspaces/$workspaceId/sops': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/workspaces/$workspaceId/sources': typeof protectedWorkspacesWorkspaceIdSourcesIndexRoute
  '/workspaces/$workspaceId/tasks': typeof protectedWorkspacesWorkspaceIdTasksIndexRoute
  '/workspaces/$workspaceId/templates': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/workspaces/$workspaceId/branches': typeof protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute
  '/workspaces/$workspaceId/change-requests': typeof protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute
  '/workspaces/$workspaceId/flows': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/workspaces/$workspaceId/integrations': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/workspaces/$workspaceId/steps': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/workspaces/$workspaceId/compliance/runs/$executionId': typeof protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute
  '/workspaces/$workspaceId/compliance/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute
  '/workspaces/$workspaceId/compliance/tests/$testId': typeof protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute
  '/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/workspaces/$workspaceId/compliance/automation/identities': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute
  '/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/workspaces/$workspaceId/compliance/$frameworkId': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute
  '/workspaces/$workspaceId/compliance/policies': typeof protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute
  '/workspaces/$workspaceId/compliance/populations': typeof protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute
  '/workspaces/$workspaceId/compliance/runs': typeof protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute
  '/workspaces/$workspaceId/compliance/setup': typeof protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute
  '/workspaces/$workspaceId/compliance/tasks': typeof protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute
  '/workspaces/$workspaceId/sops/$sopId': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/workspaces/$workspaceId/steps/$id': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
  '/workspaces/$workspaceId/templates/$templateId': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/workspaces/$workspaceId/change-requests/$changeRequestId': typeof protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute
  '/workspaces/$workspaceId/compliance/automation': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute
  '/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute
  '/workspaces/$workspaceId/compliance/$frameworkId/controls': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute
  '/workspaces/$workspaceId/compliance/automation/$executionId': typeof protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute
  '/workspaces/$workspaceId/templates/control/$controlId': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/(protected)/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/(protected)/partner': typeof protectedPartnerRouteRouteWithChildren
  '/(protected)/settings': typeof protectedSettingsRouteRouteWithChildren
  '/(protected)/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/(auth)/accept-invitation': typeof authAcceptInvitationRoute
  '/(auth)/invite': typeof authInviteRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/logout': typeof authLogoutRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/share-invite': typeof authShareInviteRoute
  '/(auth)/sop-share-invite': typeof authSopShareInviteRoute
  '/(auth)/sop-share-verify-otp': typeof authSopShareVerifyOtpRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/login-2': typeof authLogin2LazyRoute
  '/(auth)/signup': typeof authSignupLazyRoute
  '/(auth)/verify-2fa': typeof authVerify2faLazyRoute
  '/(auth)/verify-otp': typeof authVerifyOtpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/(protected)/': typeof protectedIndexRoute
  '/(protected)/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/(protected)/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/(auth)/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/(auth)/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/(auth)/native/login': typeof authNativeLoginRoute
  '/(protected)/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/(protected)/partner/templates': typeof protectedPartnerTemplatesRoute
  '/(protected)/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/(protected)/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/(protected)/settings/auth': typeof protectedSettingsAuthRoute
  '/(protected)/settings/billing': typeof protectedSettingsBillingRoute
  '/(protected)/settings/branding': typeof protectedSettingsBrandingRoute
  '/(protected)/settings/chat': typeof protectedSettingsChatRoute
  '/(protected)/settings/checks': typeof protectedSettingsChecksRoute
  '/(protected)/settings/compliance': typeof protectedSettingsComplianceRoute
  '/(protected)/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/(protected)/settings/general': typeof protectedSettingsGeneralRoute
  '/(protected)/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/(protected)/settings/members': typeof protectedSettingsMembersRoute
  '/(protected)/settings/organization': typeof protectedSettingsOrganizationRoute
  '/(protected)/settings/personas': typeof protectedSettingsPersonasRoute
  '/(protected)/settings/profile': typeof protectedSettingsProfileRoute
  '/(protected)/settings/properties': typeof protectedSettingsPropertiesRoute
  '/(protected)/settings/publishing': typeof protectedSettingsPublishingRoute
  '/(protected)/settings/review': typeof protectedSettingsReviewRoute
  '/(protected)/settings/security': typeof protectedSettingsSecurityRoute
  '/(protected)/settings/signing': typeof protectedSettingsSigningRoute
  '/(protected)/settings/templates': typeof protectedSettingsTemplatesRoute
  '/(protected)/settings/theme': typeof protectedSettingsThemeRoute
  '/(protected)/settings/writing': typeof protectedSettingsWritingRoute
  '/(protected)/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/shared/test/$shareToken': typeof SharedTestShareTokenLazyRoute
  '/(protected)/partner/': typeof protectedPartnerIndexRoute
  '/(protected)/settings/': typeof protectedSettingsIndexRoute
  '/(protected)/tasks/': typeof protectedTasksIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/evidence/verify/': typeof EvidenceVerifyIndexRoute
  '/export/sop-embed/': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf/': typeof ExportSopPdfIndexRoute
  '/export/topic-embed/': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf/': typeof ExportTopicPdfIndexRoute
  '/(protected)/integrations/': typeof protectedIntegrationsIndexLazyRoute
  '/(protected)/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/(protected)/orgs/': typeof protectedOrgsIndexLazyRoute
  '/(protected)/team/': typeof protectedTeamIndexLazyRoute
  '/(protected)/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/compliance': typeof protectedWorkspacesWorkspaceIdComplianceRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/docs': typeof protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/import': typeof protectedWorkspacesWorkspaceIdImportRouteRoute
  '/(protected)/workspaces/$workspaceId/publish': typeof protectedWorkspacesWorkspaceIdPublishRouteRouteWithChildren
  '/(protected)/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/(protected)/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/(protected)/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/(protected)/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/(protected)/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/(protected)/workspaces/$workspaceId/review-topics': typeof protectedWorkspacesWorkspaceIdReviewTopicsRoute
  '/(protected)/workspaces/$workspaceId/summary': typeof protectedWorkspacesWorkspaceIdSummaryRoute
  '/(protected)/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/(protected)/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/(protected)/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/(protected)/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/(protected)/settings/service-accounts/': typeof protectedSettingsServiceAccountsIndexRoute
  '/(protected)/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/(protected)/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/(protected)/workspaces/$workspaceId/docs/$': typeof protectedWorkspacesWorkspaceIdDocsSplatRoute
  '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/(protected)/workspaces/$workspaceId/evidence/$evidenceId': typeof protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute
  '/(protected)/workspaces/$workspaceId/evidence/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/(protected)/workspaces/$workspaceId/evidence/review-queue': typeof protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute
  '/(protected)/workspaces/$workspaceId/evidence/work-queue': typeof protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute
  '/(protected)/workspaces/$workspaceId/generate/doc': typeof protectedWorkspacesWorkspaceIdGenerateDocRoute
  '/(protected)/workspaces/$workspaceId/publish/files': typeof protectedWorkspacesWorkspaceIdPublishFilesRoute
  '/(protected)/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/(protected)/workspaces/$workspaceId/screenata/approvals': typeof protectedWorkspacesWorkspaceIdScreenataApprovalsRoute
  '/(protected)/workspaces/$workspaceId/screenata/connect-repo': typeof protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute
  '/(protected)/workspaces/$workspaceId/screenata/evidence': typeof protectedWorkspacesWorkspaceIdScreenataEvidenceRoute
  '/(protected)/workspaces/$workspaceId/screenata/generate-policies': typeof protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute
  '/(protected)/workspaces/$workspaceId/screenata/integrations': typeof protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute
  '/(protected)/workspaces/$workspaceId/screenata/policies': typeof protectedWorkspacesWorkspaceIdScreenataPoliciesRoute
  '/(protected)/workspaces/$workspaceId/screenata/readiness': typeof protectedWorkspacesWorkspaceIdScreenataReadinessRoute
  '/(protected)/workspaces/$workspaceId/screenata/scope-confirm': typeof protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute
  '/(protected)/workspaces/$workspaceId/screenata/test-outline': typeof protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute
  '/(protected)/workspaces/$workspaceId/screenata/tests': typeof protectedWorkspacesWorkspaceIdScreenataTestsRoute
  '/(protected)/workspaces/$workspaceId/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/(protected)/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/(protected)/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/(protected)/workspaces/$workspaceId/publish/deployments': typeof protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute
  '/(protected)/workspaces/$workspaceId/publish/stage': typeof protectedWorkspacesWorkspaceIdPublishStageLazyRoute
  '/(protected)/workspaces/$workspaceId/compliance/': typeof protectedWorkspacesWorkspaceIdComplianceIndexRoute
  '/(protected)/workspaces/$workspaceId/dashboard/': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/(protected)/workspaces/$workspaceId/evidence/': typeof protectedWorkspacesWorkspaceIdEvidenceIndexRoute
  '/(protected)/workspaces/$workspaceId/glossary/': typeof protectedWorkspacesWorkspaceIdGlossaryIndexRoute
  '/(protected)/workspaces/$workspaceId/knowledge-gaps/': typeof protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute
  '/(protected)/workspaces/$workspaceId/publish/': typeof protectedWorkspacesWorkspaceIdPublishIndexRoute
  '/(protected)/workspaces/$workspaceId/pulse/': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/(protected)/workspaces/$workspaceId/screenata/': typeof protectedWorkspacesWorkspaceIdScreenataIndexRoute
  '/(protected)/workspaces/$workspaceId/sops/': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/(protected)/workspaces/$workspaceId/sources/': typeof protectedWorkspacesWorkspaceIdSourcesIndexRoute
  '/(protected)/workspaces/$workspaceId/tasks/': typeof protectedWorkspacesWorkspaceIdTasksIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/(protected)/workspaces/$workspaceId/branches/': typeof protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/change-requests/': typeof protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/flows/': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/integrations/': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/steps/': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/compliance/runs/$executionId': typeof protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute
  '/(protected)/workspaces/$workspaceId/compliance/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute
  '/(protected)/workspaces/$workspaceId/compliance/tests/$testId': typeof protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute
  '/(protected)/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/(protected)/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/(protected)/workspaces/$workspaceId/compliance/automation/identities': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute
  '/(protected)/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/policies/': typeof protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/populations/': typeof protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/runs/': typeof protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/setup/': typeof protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/tasks/': typeof protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute
  '/(protected)/workspaces/$workspaceId/sops/$sopId/': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/(protected)/workspaces/$workspaceId/steps/$id/': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/$templateId/': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/': typeof protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/compliance/automation/': typeof protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute
  '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/controls/': typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute
  '/(protected)/workspaces/$workspaceId/compliance/automation/$executionId/': typeof protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/control/$controlId/': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/extension-uninstalled'
    | '/orgs'
    | '/partner'
    | '/settings'
    | '/workspaces'
    | '/accept-invitation'
    | '/invite'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/share-invite'
    | '/sop-share-invite'
    | '/sop-share-verify-otp'
    | '/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/forgot-password'
    | '/login-2'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared-sop/$shareId'
    | '/shared/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/workspaces/$workspaceId'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/dev/plan-restrictions-test'
    | '/partner/templates'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/auth'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/chat'
    | '/settings/checks'
    | '/settings/compliance'
    | '/settings/configuration'
    | '/settings/general'
    | '/settings/mcp-server'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/personas'
    | '/settings/profile'
    | '/settings/properties'
    | '/settings/publishing'
    | '/settings/review'
    | '/settings/security'
    | '/settings/signing'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/writing'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/shared/test/$shareToken'
    | '/partner/'
    | '/settings/'
    | '/tasks/'
    | '/demo/tiptap/'
    | '/evidence/verify/'
    | '/export/sop-embed/'
    | '/export/sop-pdf/'
    | '/export/topic-embed/'
    | '/export/topic-pdf/'
    | '/integrations/'
    | '/onboarding/'
    | '/orgs/'
    | '/team/'
    | '/workspaces/'
    | '/workspaces/$workspaceId/compliance'
    | '/workspaces/$workspaceId/docs'
    | '/workspaces/$workspaceId/import'
    | '/workspaces/$workspaceId/publish'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/analytics'
    | '/workspaces/$workspaceId/edit'
    | '/workspaces/$workspaceId/review-topics'
    | '/workspaces/$workspaceId/summary'
    | '/workspaces/$workspaceId/video-processing'
    | '/onboarding/$organizationId/workspace'
    | '/workspaces/$workspaceId/agent-reliability'
    | '/workspaces/$workspaceId/git-settings'
    | '/settings/service-accounts/'
    | '/workspace/integrations/'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/docs/$'
    | '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/workspaces/$workspaceId/evidence/$evidenceId'
    | '/workspaces/$workspaceId/evidence/creating'
    | '/workspaces/$workspaceId/evidence/review-queue'
    | '/workspaces/$workspaceId/evidence/work-queue'
    | '/workspaces/$workspaceId/generate/doc'
    | '/workspaces/$workspaceId/publish/files'
    | '/workspaces/$workspaceId/pulse/configure'
    | '/workspaces/$workspaceId/screenata/approvals'
    | '/workspaces/$workspaceId/screenata/connect-repo'
    | '/workspaces/$workspaceId/screenata/evidence'
    | '/workspaces/$workspaceId/screenata/generate-policies'
    | '/workspaces/$workspaceId/screenata/integrations'
    | '/workspaces/$workspaceId/screenata/policies'
    | '/workspaces/$workspaceId/screenata/readiness'
    | '/workspaces/$workspaceId/screenata/scope-confirm'
    | '/workspaces/$workspaceId/screenata/test-outline'
    | '/workspaces/$workspaceId/screenata/tests'
    | '/workspaces/$workspaceId/tasks/$taskId'
    | '/workspaces/$workspaceId/templates/new'
    | '/workspaces/$workspaceId/templates/public'
    | '/workspaces/$workspaceId/publish/deployments'
    | '/workspaces/$workspaceId/publish/stage'
    | '/workspaces/$workspaceId/compliance/'
    | '/workspaces/$workspaceId/dashboard/'
    | '/workspaces/$workspaceId/evidence/'
    | '/workspaces/$workspaceId/glossary/'
    | '/workspaces/$workspaceId/knowledge-gaps/'
    | '/workspaces/$workspaceId/publish/'
    | '/workspaces/$workspaceId/pulse/'
    | '/workspaces/$workspaceId/screenata/'
    | '/workspaces/$workspaceId/sops/'
    | '/workspaces/$workspaceId/sources/'
    | '/workspaces/$workspaceId/tasks/'
    | '/workspaces/$workspaceId/templates/'
    | '/workspaces/$workspaceId/branches/'
    | '/workspaces/$workspaceId/change-requests/'
    | '/workspaces/$workspaceId/flows/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/steps/'
    | '/workspaces/$workspaceId/compliance/runs/$executionId'
    | '/workspaces/$workspaceId/compliance/submissions/$submissionId'
    | '/workspaces/$workspaceId/compliance/tests/$testId'
    | '/workspaces/$workspaceId/sops/$sopId/generate'
    | '/workspaces/$workspaceId/templates/$templateId/edit'
    | '/workspaces/$workspaceId/compliance/automation/identities'
    | '/workspaces/$workspaceId/flows/$flowId/view'
    | '/workspaces/$workspaceId/compliance/$frameworkId/'
    | '/workspaces/$workspaceId/compliance/policies/'
    | '/workspaces/$workspaceId/compliance/populations/'
    | '/workspaces/$workspaceId/compliance/runs/'
    | '/workspaces/$workspaceId/compliance/setup/'
    | '/workspaces/$workspaceId/compliance/tasks/'
    | '/workspaces/$workspaceId/sops/$sopId/'
    | '/workspaces/$workspaceId/steps/$id/'
    | '/workspaces/$workspaceId/templates/$templateId/'
    | '/workspaces/$workspaceId/change-requests/$changeRequestId/'
    | '/workspaces/$workspaceId/compliance/automation/'
    | '/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'
    | '/workspaces/$workspaceId/compliance/$frameworkId/controls/'
    | '/workspaces/$workspaceId/compliance/automation/$executionId/'
    | '/workspaces/$workspaceId/templates/control/$controlId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/extension-uninstalled'
    | '/accept-invitation'
    | '/invite'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/share-invite'
    | '/sop-share-invite'
    | '/sop-share-verify-otp'
    | '/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/forgot-password'
    | '/login-2'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared-sop/$shareId'
    | '/shared/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/dev/plan-restrictions-test'
    | '/partner/templates'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/auth'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/chat'
    | '/settings/checks'
    | '/settings/compliance'
    | '/settings/configuration'
    | '/settings/general'
    | '/settings/mcp-server'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/personas'
    | '/settings/profile'
    | '/settings/properties'
    | '/settings/publishing'
    | '/settings/review'
    | '/settings/security'
    | '/settings/signing'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/writing'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/shared/test/$shareToken'
    | '/partner'
    | '/settings'
    | '/tasks'
    | '/demo/tiptap'
    | '/evidence/verify'
    | '/export/sop-embed'
    | '/export/sop-pdf'
    | '/export/topic-embed'
    | '/export/topic-pdf'
    | '/integrations'
    | '/onboarding'
    | '/orgs'
    | '/team'
    | '/workspaces'
    | '/workspaces/$workspaceId/docs'
    | '/workspaces/$workspaceId/import'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/analytics'
    | '/workspaces/$workspaceId/edit'
    | '/workspaces/$workspaceId/review-topics'
    | '/workspaces/$workspaceId/summary'
    | '/workspaces/$workspaceId/video-processing'
    | '/onboarding/$organizationId/workspace'
    | '/workspaces/$workspaceId/agent-reliability'
    | '/workspaces/$workspaceId/git-settings'
    | '/settings/service-accounts'
    | '/workspace/integrations'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/docs/$'
    | '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/workspaces/$workspaceId/evidence/$evidenceId'
    | '/workspaces/$workspaceId/evidence/creating'
    | '/workspaces/$workspaceId/evidence/review-queue'
    | '/workspaces/$workspaceId/evidence/work-queue'
    | '/workspaces/$workspaceId/generate/doc'
    | '/workspaces/$workspaceId/publish/files'
    | '/workspaces/$workspaceId/pulse/configure'
    | '/workspaces/$workspaceId/screenata/approvals'
    | '/workspaces/$workspaceId/screenata/connect-repo'
    | '/workspaces/$workspaceId/screenata/evidence'
    | '/workspaces/$workspaceId/screenata/generate-policies'
    | '/workspaces/$workspaceId/screenata/integrations'
    | '/workspaces/$workspaceId/screenata/policies'
    | '/workspaces/$workspaceId/screenata/readiness'
    | '/workspaces/$workspaceId/screenata/scope-confirm'
    | '/workspaces/$workspaceId/screenata/test-outline'
    | '/workspaces/$workspaceId/screenata/tests'
    | '/workspaces/$workspaceId/tasks/$taskId'
    | '/workspaces/$workspaceId/templates/new'
    | '/workspaces/$workspaceId/templates/public'
    | '/workspaces/$workspaceId/publish/deployments'
    | '/workspaces/$workspaceId/publish/stage'
    | '/workspaces/$workspaceId/compliance'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/evidence'
    | '/workspaces/$workspaceId/glossary'
    | '/workspaces/$workspaceId/knowledge-gaps'
    | '/workspaces/$workspaceId/publish'
    | '/workspaces/$workspaceId/pulse'
    | '/workspaces/$workspaceId/screenata'
    | '/workspaces/$workspaceId/sops'
    | '/workspaces/$workspaceId/sources'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/templates'
    | '/workspaces/$workspaceId/branches'
    | '/workspaces/$workspaceId/change-requests'
    | '/workspaces/$workspaceId/flows'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/steps'
    | '/workspaces/$workspaceId/compliance/runs/$executionId'
    | '/workspaces/$workspaceId/compliance/submissions/$submissionId'
    | '/workspaces/$workspaceId/compliance/tests/$testId'
    | '/workspaces/$workspaceId/sops/$sopId/generate'
    | '/workspaces/$workspaceId/templates/$templateId/edit'
    | '/workspaces/$workspaceId/compliance/automation/identities'
    | '/workspaces/$workspaceId/flows/$flowId/view'
    | '/workspaces/$workspaceId/compliance/$frameworkId'
    | '/workspaces/$workspaceId/compliance/policies'
    | '/workspaces/$workspaceId/compliance/populations'
    | '/workspaces/$workspaceId/compliance/runs'
    | '/workspaces/$workspaceId/compliance/setup'
    | '/workspaces/$workspaceId/compliance/tasks'
    | '/workspaces/$workspaceId/sops/$sopId'
    | '/workspaces/$workspaceId/steps/$id'
    | '/workspaces/$workspaceId/templates/$templateId'
    | '/workspaces/$workspaceId/change-requests/$changeRequestId'
    | '/workspaces/$workspaceId/compliance/automation'
    | '/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'
    | '/workspaces/$workspaceId/compliance/$frameworkId/controls'
    | '/workspaces/$workspaceId/compliance/automation/$executionId'
    | '/workspaces/$workspaceId/templates/control/$controlId'
  id:
    | '__root__'
    | '/(auth)'
    | '/(protected)'
    | '/extension-uninstalled'
    | '/(protected)/orgs'
    | '/(protected)/partner'
    | '/(protected)/settings'
    | '/(protected)/workspaces'
    | '/(auth)/accept-invitation'
    | '/(auth)/invite'
    | '/(auth)/login'
    | '/(auth)/logout'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/share-invite'
    | '/(auth)/sop-share-invite'
    | '/(auth)/sop-share-verify-otp'
    | '/(auth)/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/(auth)/forgot-password'
    | '/(auth)/login-2'
    | '/(auth)/signup'
    | '/(auth)/verify-2fa'
    | '/(auth)/verify-otp'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/shared-sop/$shareId'
    | '/shared/$shareId'
    | '/(protected)/'
    | '/(protected)/orgs/$slug'
    | '/(protected)/workspaces/$workspaceId'
    | '/(auth)/auth-callback/$provider'
    | '/(auth)/native/auth-callback'
    | '/(auth)/native/login'
    | '/(protected)/dev/plan-restrictions-test'
    | '/(protected)/partner/templates'
    | '/(protected)/settings/api-keys'
    | '/(protected)/settings/audit-logs'
    | '/(protected)/settings/auth'
    | '/(protected)/settings/billing'
    | '/(protected)/settings/branding'
    | '/(protected)/settings/chat'
    | '/(protected)/settings/checks'
    | '/(protected)/settings/compliance'
    | '/(protected)/settings/configuration'
    | '/(protected)/settings/general'
    | '/(protected)/settings/mcp-server'
    | '/(protected)/settings/members'
    | '/(protected)/settings/organization'
    | '/(protected)/settings/personas'
    | '/(protected)/settings/profile'
    | '/(protected)/settings/properties'
    | '/(protected)/settings/publishing'
    | '/(protected)/settings/review'
    | '/(protected)/settings/security'
    | '/(protected)/settings/signing'
    | '/(protected)/settings/templates'
    | '/(protected)/settings/theme'
    | '/(protected)/settings/writing'
    | '/(protected)/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/shared/test/$shareToken'
    | '/(protected)/partner/'
    | '/(protected)/settings/'
    | '/(protected)/tasks/'
    | '/demo/tiptap/'
    | '/evidence/verify/'
    | '/export/sop-embed/'
    | '/export/sop-pdf/'
    | '/export/topic-embed/'
    | '/export/topic-pdf/'
    | '/(protected)/integrations/'
    | '/(protected)/onboarding/'
    | '/(protected)/orgs/'
    | '/(protected)/team/'
    | '/(protected)/workspaces/'
    | '/(protected)/workspaces/$workspaceId/compliance'
    | '/(protected)/workspaces/$workspaceId/docs'
    | '/(protected)/workspaces/$workspaceId/import'
    | '/(protected)/workspaces/$workspaceId/publish'
    | '/(protected)/partner/clients/$clientId'
    | '/(protected)/partner/clients/new'
    | '/(protected)/workspace/integrations/github'
    | '/(protected)/workspaces/$workspaceId/analytics'
    | '/(protected)/workspaces/$workspaceId/edit'
    | '/(protected)/workspaces/$workspaceId/review-topics'
    | '/(protected)/workspaces/$workspaceId/summary'
    | '/(protected)/workspaces/$workspaceId/video-processing'
    | '/(protected)/onboarding/$organizationId/workspace'
    | '/(protected)/workspaces/$workspaceId/agent-reliability'
    | '/(protected)/workspaces/$workspaceId/git-settings'
    | '/(protected)/settings/service-accounts/'
    | '/(protected)/workspace/integrations/'
    | '/(protected)/workspaces/$workspaceId/'
    | '/(protected)/workspaces/$workspaceId/docs/$'
    | '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/(protected)/workspaces/$workspaceId/evidence/$evidenceId'
    | '/(protected)/workspaces/$workspaceId/evidence/creating'
    | '/(protected)/workspaces/$workspaceId/evidence/review-queue'
    | '/(protected)/workspaces/$workspaceId/evidence/work-queue'
    | '/(protected)/workspaces/$workspaceId/generate/doc'
    | '/(protected)/workspaces/$workspaceId/publish/files'
    | '/(protected)/workspaces/$workspaceId/pulse/configure'
    | '/(protected)/workspaces/$workspaceId/screenata/approvals'
    | '/(protected)/workspaces/$workspaceId/screenata/connect-repo'
    | '/(protected)/workspaces/$workspaceId/screenata/evidence'
    | '/(protected)/workspaces/$workspaceId/screenata/generate-policies'
    | '/(protected)/workspaces/$workspaceId/screenata/integrations'
    | '/(protected)/workspaces/$workspaceId/screenata/policies'
    | '/(protected)/workspaces/$workspaceId/screenata/readiness'
    | '/(protected)/workspaces/$workspaceId/screenata/scope-confirm'
    | '/(protected)/workspaces/$workspaceId/screenata/test-outline'
    | '/(protected)/workspaces/$workspaceId/screenata/tests'
    | '/(protected)/workspaces/$workspaceId/tasks/$taskId'
    | '/(protected)/workspaces/$workspaceId/templates/new'
    | '/(protected)/workspaces/$workspaceId/templates/public'
    | '/(protected)/workspaces/$workspaceId/publish/deployments'
    | '/(protected)/workspaces/$workspaceId/publish/stage'
    | '/(protected)/workspaces/$workspaceId/compliance/'
    | '/(protected)/workspaces/$workspaceId/dashboard/'
    | '/(protected)/workspaces/$workspaceId/evidence/'
    | '/(protected)/workspaces/$workspaceId/glossary/'
    | '/(protected)/workspaces/$workspaceId/knowledge-gaps/'
    | '/(protected)/workspaces/$workspaceId/publish/'
    | '/(protected)/workspaces/$workspaceId/pulse/'
    | '/(protected)/workspaces/$workspaceId/screenata/'
    | '/(protected)/workspaces/$workspaceId/sops/'
    | '/(protected)/workspaces/$workspaceId/sources/'
    | '/(protected)/workspaces/$workspaceId/tasks/'
    | '/(protected)/workspaces/$workspaceId/templates/'
    | '/(protected)/workspaces/$workspaceId/branches/'
    | '/(protected)/workspaces/$workspaceId/change-requests/'
    | '/(protected)/workspaces/$workspaceId/flows/'
    | '/(protected)/workspaces/$workspaceId/integrations/'
    | '/(protected)/workspaces/$workspaceId/steps/'
    | '/(protected)/workspaces/$workspaceId/compliance/runs/$executionId'
    | '/(protected)/workspaces/$workspaceId/compliance/submissions/$submissionId'
    | '/(protected)/workspaces/$workspaceId/compliance/tests/$testId'
    | '/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
    | '/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
    | '/(protected)/workspaces/$workspaceId/compliance/automation/identities'
    | '/(protected)/workspaces/$workspaceId/flows/$flowId/view'
    | '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/'
    | '/(protected)/workspaces/$workspaceId/compliance/policies/'
    | '/(protected)/workspaces/$workspaceId/compliance/populations/'
    | '/(protected)/workspaces/$workspaceId/compliance/runs/'
    | '/(protected)/workspaces/$workspaceId/compliance/setup/'
    | '/(protected)/workspaces/$workspaceId/compliance/tasks/'
    | '/(protected)/workspaces/$workspaceId/sops/$sopId/'
    | '/(protected)/workspaces/$workspaceId/steps/$id/'
    | '/(protected)/workspaces/$workspaceId/templates/$templateId/'
    | '/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/'
    | '/(protected)/workspaces/$workspaceId/compliance/automation/'
    | '/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'
    | '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/controls/'
    | '/(protected)/workspaces/$workspaceId/compliance/automation/$executionId/'
    | '/(protected)/workspaces/$workspaceId/templates/control/$controlId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
  ExtensionUninstalledLazyRoute: typeof ExtensionUninstalledLazyRoute
  DemoPulseRoute: typeof DemoPulseRoute
  IntegrationsGithubAppCallbackRoute: typeof IntegrationsGithubAppCallbackRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  SharedSopShareIdLazyRoute: typeof SharedSopShareIdLazyRoute
  SharedShareIdLazyRoute: typeof SharedShareIdLazyRoute
  DemoTiptapAiChangesRoute: typeof DemoTiptapAiChangesRoute
  DemoTiptapAiSuggestionRoute: typeof DemoTiptapAiSuggestionRoute
  SharedTestShareTokenLazyRoute: typeof SharedTestShareTokenLazyRoute
  DemoTiptapIndexRoute: typeof DemoTiptapIndexRoute
  EvidenceVerifyIndexRoute: typeof EvidenceVerifyIndexRoute
  ExportSopEmbedIndexRoute: typeof ExportSopEmbedIndexRoute
  ExportSopPdfIndexRoute: typeof ExportSopPdfIndexRoute
  ExportTopicEmbedIndexRoute: typeof ExportTopicEmbedIndexRoute
  ExportTopicPdfIndexRoute: typeof ExportTopicPdfIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/extension-uninstalled': {
      id: '/extension-uninstalled'
      path: '/extension-uninstalled'
      fullPath: '/extension-uninstalled'
      preLoaderRoute: typeof ExtensionUninstalledLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)': {
      id: '/(protected)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/': {
      id: '/(protected)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof protectedIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/shared/$shareId': {
      id: '/shared/$shareId'
      path: '/shared/$shareId'
      fullPath: '/shared/$shareId'
      preLoaderRoute: typeof SharedShareIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-sop/$shareId': {
      id: '/shared-sop/$shareId'
      path: '/shared-sop/$shareId'
      fullPath: '/shared-sop/$shareId'
      preLoaderRoute: typeof SharedSopShareIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-otp': {
      id: '/(auth)/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof authVerifyOtpLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/verify-2fa': {
      id: '/(auth)/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof authVerify2faLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/signup': {
      id: '/(auth)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof authSignupLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login-2': {
      id: '/(auth)/login-2'
      path: '/login-2'
      fullPath: '/login-2'
      preLoaderRoute: typeof authLogin2LazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/integrations/github-app-callback': {
      id: '/integrations/github-app-callback'
      path: '/integrations/github-app-callback'
      fullPath: '/integrations/github-app-callback'
      preLoaderRoute: typeof IntegrationsGithubAppCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/pulse': {
      id: '/demo/pulse'
      path: '/demo/pulse'
      fullPath: '/demo/pulse'
      preLoaderRoute: typeof DemoPulseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sop-share-verify-otp': {
      id: '/(auth)/sop-share-verify-otp'
      path: '/sop-share-verify-otp'
      fullPath: '/sop-share-verify-otp'
      preLoaderRoute: typeof authSopShareVerifyOtpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sop-share-invite': {
      id: '/(auth)/sop-share-invite'
      path: '/sop-share-invite'
      fullPath: '/sop-share-invite'
      preLoaderRoute: typeof authSopShareInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/share-invite': {
      id: '/(auth)/share-invite'
      path: '/share-invite'
      fullPath: '/share-invite'
      preLoaderRoute: typeof authShareInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/logout': {
      id: '/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof authLogoutRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/invite': {
      id: '/(auth)/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof authInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/accept-invitation': {
      id: '/(auth)/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof authAcceptInvitationRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces': {
      id: '/(protected)/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof protectedWorkspacesRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings': {
      id: '/(protected)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof protectedSettingsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner': {
      id: '/(protected)/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof protectedPartnerRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/orgs': {
      id: '/(protected)/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof protectedOrgsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/workspaces/': {
      id: '/(protected)/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof protectedWorkspacesIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/team/': {
      id: '/(protected)/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof protectedTeamIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/orgs/': {
      id: '/(protected)/orgs/'
      path: '/'
      fullPath: '/orgs/'
      preLoaderRoute: typeof protectedOrgsIndexLazyRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/onboarding/': {
      id: '/(protected)/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof protectedOnboardingIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/integrations/': {
      id: '/(protected)/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof protectedIntegrationsIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/export/topic-pdf/': {
      id: '/export/topic-pdf/'
      path: '/export/topic-pdf'
      fullPath: '/export/topic-pdf/'
      preLoaderRoute: typeof ExportTopicPdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/topic-embed/': {
      id: '/export/topic-embed/'
      path: '/export/topic-embed'
      fullPath: '/export/topic-embed/'
      preLoaderRoute: typeof ExportTopicEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/sop-pdf/': {
      id: '/export/sop-pdf/'
      path: '/export/sop-pdf'
      fullPath: '/export/sop-pdf/'
      preLoaderRoute: typeof ExportSopPdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/sop-embed/': {
      id: '/export/sop-embed/'
      path: '/export/sop-embed'
      fullPath: '/export/sop-embed/'
      preLoaderRoute: typeof ExportSopEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evidence/verify/': {
      id: '/evidence/verify/'
      path: '/evidence/verify'
      fullPath: '/evidence/verify/'
      preLoaderRoute: typeof EvidenceVerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/': {
      id: '/demo/tiptap/'
      path: '/demo/tiptap'
      fullPath: '/demo/tiptap/'
      preLoaderRoute: typeof DemoTiptapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/tasks/': {
      id: '/(protected)/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof protectedTasksIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/': {
      id: '/(protected)/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof protectedSettingsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/partner/': {
      id: '/(protected)/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof protectedPartnerIndexRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/shared/test/$shareToken': {
      id: '/shared/test/$shareToken'
      path: '/shared/test/$shareToken'
      fullPath: '/shared/test/$shareToken'
      preLoaderRoute: typeof SharedTestShareTokenLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/ai-suggestion': {
      id: '/demo/tiptap/ai-suggestion'
      path: '/demo/tiptap/ai-suggestion'
      fullPath: '/demo/tiptap/ai-suggestion'
      preLoaderRoute: typeof DemoTiptapAiSuggestionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/ai-changes': {
      id: '/demo/tiptap/ai-changes'
      path: '/demo/tiptap/ai-changes'
      fullPath: '/demo/tiptap/ai-changes'
      preLoaderRoute: typeof DemoTiptapAiChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/workspaces/new': {
      id: '/(protected)/workspaces/new'
      path: '/new'
      fullPath: '/workspaces/new'
      preLoaderRoute: typeof protectedWorkspacesNewRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/settings/writing': {
      id: '/(protected)/settings/writing'
      path: '/writing'
      fullPath: '/settings/writing'
      preLoaderRoute: typeof protectedSettingsWritingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/theme': {
      id: '/(protected)/settings/theme'
      path: '/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof protectedSettingsThemeRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/templates': {
      id: '/(protected)/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof protectedSettingsTemplatesRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/signing': {
      id: '/(protected)/settings/signing'
      path: '/signing'
      fullPath: '/settings/signing'
      preLoaderRoute: typeof protectedSettingsSigningRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/security': {
      id: '/(protected)/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof protectedSettingsSecurityRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/review': {
      id: '/(protected)/settings/review'
      path: '/review'
      fullPath: '/settings/review'
      preLoaderRoute: typeof protectedSettingsReviewRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/publishing': {
      id: '/(protected)/settings/publishing'
      path: '/publishing'
      fullPath: '/settings/publishing'
      preLoaderRoute: typeof protectedSettingsPublishingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/properties': {
      id: '/(protected)/settings/properties'
      path: '/properties'
      fullPath: '/settings/properties'
      preLoaderRoute: typeof protectedSettingsPropertiesRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/profile': {
      id: '/(protected)/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof protectedSettingsProfileRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/personas': {
      id: '/(protected)/settings/personas'
      path: '/personas'
      fullPath: '/settings/personas'
      preLoaderRoute: typeof protectedSettingsPersonasRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/organization': {
      id: '/(protected)/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof protectedSettingsOrganizationRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/members': {
      id: '/(protected)/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof protectedSettingsMembersRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/mcp-server': {
      id: '/(protected)/settings/mcp-server'
      path: '/mcp-server'
      fullPath: '/settings/mcp-server'
      preLoaderRoute: typeof protectedSettingsMcpServerRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/general': {
      id: '/(protected)/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof protectedSettingsGeneralRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/configuration': {
      id: '/(protected)/settings/configuration'
      path: '/configuration'
      fullPath: '/settings/configuration'
      preLoaderRoute: typeof protectedSettingsConfigurationRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/compliance': {
      id: '/(protected)/settings/compliance'
      path: '/compliance'
      fullPath: '/settings/compliance'
      preLoaderRoute: typeof protectedSettingsComplianceRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/checks': {
      id: '/(protected)/settings/checks'
      path: '/checks'
      fullPath: '/settings/checks'
      preLoaderRoute: typeof protectedSettingsChecksRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/chat': {
      id: '/(protected)/settings/chat'
      path: '/chat'
      fullPath: '/settings/chat'
      preLoaderRoute: typeof protectedSettingsChatRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/branding': {
      id: '/(protected)/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof protectedSettingsBrandingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/billing': {
      id: '/(protected)/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof protectedSettingsBillingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/auth': {
      id: '/(protected)/settings/auth'
      path: '/auth'
      fullPath: '/settings/auth'
      preLoaderRoute: typeof protectedSettingsAuthRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/audit-logs': {
      id: '/(protected)/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof protectedSettingsAuditLogsRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/api-keys': {
      id: '/(protected)/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof protectedSettingsApiKeysRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/partner/templates': {
      id: '/(protected)/partner/templates'
      path: '/templates'
      fullPath: '/partner/templates'
      preLoaderRoute: typeof protectedPartnerTemplatesRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/dev/plan-restrictions-test': {
      id: '/(protected)/dev/plan-restrictions-test'
      path: '/dev/plan-restrictions-test'
      fullPath: '/dev/plan-restrictions-test'
      preLoaderRoute: typeof protectedDevPlanRestrictionsTestRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/native/login': {
      id: '/(auth)/native/login'
      path: '/native/login'
      fullPath: '/native/login'
      preLoaderRoute: typeof authNativeLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/native/auth-callback': {
      id: '/(auth)/native/auth-callback'
      path: '/native/auth-callback'
      fullPath: '/native/auth-callback'
      preLoaderRoute: typeof authNativeAuthCallbackRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/auth-callback/$provider': {
      id: '/(auth)/auth-callback/$provider'
      path: '/auth-callback/$provider'
      fullPath: '/auth-callback/$provider'
      preLoaderRoute: typeof authAuthCallbackProviderRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces/$workspaceId': {
      id: '/(protected)/workspaces/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/orgs/$slug': {
      id: '/(protected)/orgs/$slug'
      path: '/$slug'
      fullPath: '/orgs/$slug'
      preLoaderRoute: typeof protectedOrgsSlugRouteRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/': {
      id: '/(protected)/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/': {
      id: '/(protected)/workspace/integrations/'
      path: '/workspace/integrations'
      fullPath: '/workspace/integrations/'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/service-accounts/': {
      id: '/(protected)/settings/service-accounts/'
      path: '/service-accounts'
      fullPath: '/settings/service-accounts/'
      preLoaderRoute: typeof protectedSettingsServiceAccountsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/git-settings': {
      id: '/(protected)/workspaces/$workspaceId/git-settings'
      path: '/git-settings'
      fullPath: '/workspaces/$workspaceId/git-settings'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/agent-reliability': {
      id: '/(protected)/workspaces/$workspaceId/agent-reliability'
      path: '/agent-reliability'
      fullPath: '/workspaces/$workspaceId/agent-reliability'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/onboarding/$organizationId/workspace': {
      id: '/(protected)/onboarding/$organizationId/workspace'
      path: '/onboarding/$organizationId/workspace'
      fullPath: '/onboarding/$organizationId/workspace'
      preLoaderRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/video-processing': {
      id: '/(protected)/workspaces/$workspaceId/video-processing'
      path: '/video-processing'
      fullPath: '/workspaces/$workspaceId/video-processing'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdVideoProcessingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/summary': {
      id: '/(protected)/workspaces/$workspaceId/summary'
      path: '/summary'
      fullPath: '/workspaces/$workspaceId/summary'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSummaryRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/review-topics': {
      id: '/(protected)/workspaces/$workspaceId/review-topics'
      path: '/review-topics'
      fullPath: '/workspaces/$workspaceId/review-topics'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReviewTopicsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/edit': {
      id: '/(protected)/workspaces/$workspaceId/edit'
      path: '/edit'
      fullPath: '/workspaces/$workspaceId/edit'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEditRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/analytics': {
      id: '/(protected)/workspaces/$workspaceId/analytics'
      path: '/analytics'
      fullPath: '/workspaces/$workspaceId/analytics'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAnalyticsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/github': {
      id: '/(protected)/workspace/integrations/github'
      path: '/workspace/integrations/github'
      fullPath: '/workspace/integrations/github'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsGithubRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner/clients/new': {
      id: '/(protected)/partner/clients/new'
      path: '/clients/new'
      fullPath: '/partner/clients/new'
      preLoaderRoute: typeof protectedPartnerClientsNewRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/partner/clients/$clientId': {
      id: '/(protected)/partner/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/partner/clients/$clientId'
      preLoaderRoute: typeof protectedPartnerClientsClientIdRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/publish': {
      id: '/(protected)/workspaces/$workspaceId/publish'
      path: '/publish'
      fullPath: '/workspaces/$workspaceId/publish'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/import': {
      id: '/(protected)/workspaces/$workspaceId/import'
      path: '/import'
      fullPath: '/workspaces/$workspaceId/import'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdImportRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/docs': {
      id: '/(protected)/workspaces/$workspaceId/docs'
      path: '/docs'
      fullPath: '/workspaces/$workspaceId/docs'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDocsRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance': {
      id: '/(protected)/workspaces/$workspaceId/compliance'
      path: '/compliance'
      fullPath: '/workspaces/$workspaceId/compliance'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/steps/': {
      id: '/(protected)/workspaces/$workspaceId/steps/'
      path: '/steps'
      fullPath: '/workspaces/$workspaceId/steps/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations/': {
      id: '/(protected)/workspaces/$workspaceId/integrations/'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/flows/': {
      id: '/(protected)/workspaces/$workspaceId/flows/'
      path: '/flows'
      fullPath: '/workspaces/$workspaceId/flows/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/change-requests/': {
      id: '/(protected)/workspaces/$workspaceId/change-requests/'
      path: '/change-requests'
      fullPath: '/workspaces/$workspaceId/change-requests/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/branches/': {
      id: '/(protected)/workspaces/$workspaceId/branches/'
      path: '/branches'
      fullPath: '/workspaces/$workspaceId/branches/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdBranchesIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/': {
      id: '/(protected)/workspaces/$workspaceId/templates/'
      path: '/templates'
      fullPath: '/workspaces/$workspaceId/templates/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tasks/': {
      id: '/(protected)/workspaces/$workspaceId/tasks/'
      path: '/tasks'
      fullPath: '/workspaces/$workspaceId/tasks/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTasksIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sources/': {
      id: '/(protected)/workspaces/$workspaceId/sources/'
      path: '/sources'
      fullPath: '/workspaces/$workspaceId/sources/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSourcesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/': {
      id: '/(protected)/workspaces/$workspaceId/sops/'
      path: '/sops'
      fullPath: '/workspaces/$workspaceId/sops/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/': {
      id: '/(protected)/workspaces/$workspaceId/screenata/'
      path: '/screenata'
      fullPath: '/workspaces/$workspaceId/screenata/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/pulse/': {
      id: '/(protected)/workspaces/$workspaceId/pulse/'
      path: '/pulse'
      fullPath: '/workspaces/$workspaceId/pulse/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPulseIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/publish/': {
      id: '/(protected)/workspaces/$workspaceId/publish/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/publish/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPublishIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/knowledge-gaps/': {
      id: '/(protected)/workspaces/$workspaceId/knowledge-gaps/'
      path: '/knowledge-gaps'
      fullPath: '/workspaces/$workspaceId/knowledge-gaps/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/glossary/': {
      id: '/(protected)/workspaces/$workspaceId/glossary/'
      path: '/glossary'
      fullPath: '/workspaces/$workspaceId/glossary/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdGlossaryIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence/': {
      id: '/(protected)/workspaces/$workspaceId/evidence/'
      path: '/evidence'
      fullPath: '/workspaces/$workspaceId/evidence/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/dashboard/': {
      id: '/(protected)/workspaces/$workspaceId/dashboard/'
      path: '/dashboard'
      fullPath: '/workspaces/$workspaceId/dashboard/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDashboardIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/compliance/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/publish/stage': {
      id: '/(protected)/workspaces/$workspaceId/publish/stage'
      path: '/stage'
      fullPath: '/workspaces/$workspaceId/publish/stage'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPublishStageLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/publish/deployments': {
      id: '/(protected)/workspaces/$workspaceId/publish/deployments'
      path: '/deployments'
      fullPath: '/workspaces/$workspaceId/publish/deployments'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/public': {
      id: '/(protected)/workspaces/$workspaceId/templates/public'
      path: '/templates/public'
      fullPath: '/workspaces/$workspaceId/templates/public'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/new': {
      id: '/(protected)/workspaces/$workspaceId/templates/new'
      path: '/templates/new'
      fullPath: '/workspaces/$workspaceId/templates/new'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesNewRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tasks/$taskId': {
      id: '/(protected)/workspaces/$workspaceId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/workspaces/$workspaceId/tasks/$taskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/tests': {
      id: '/(protected)/workspaces/$workspaceId/screenata/tests'
      path: '/screenata/tests'
      fullPath: '/workspaces/$workspaceId/screenata/tests'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataTestsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/test-outline': {
      id: '/(protected)/workspaces/$workspaceId/screenata/test-outline'
      path: '/screenata/test-outline'
      fullPath: '/workspaces/$workspaceId/screenata/test-outline'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataTestOutlineRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/scope-confirm': {
      id: '/(protected)/workspaces/$workspaceId/screenata/scope-confirm'
      path: '/screenata/scope-confirm'
      fullPath: '/workspaces/$workspaceId/screenata/scope-confirm'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataScopeConfirmRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/readiness': {
      id: '/(protected)/workspaces/$workspaceId/screenata/readiness'
      path: '/screenata/readiness'
      fullPath: '/workspaces/$workspaceId/screenata/readiness'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataReadinessRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/policies': {
      id: '/(protected)/workspaces/$workspaceId/screenata/policies'
      path: '/screenata/policies'
      fullPath: '/workspaces/$workspaceId/screenata/policies'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataPoliciesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/integrations': {
      id: '/(protected)/workspaces/$workspaceId/screenata/integrations'
      path: '/screenata/integrations'
      fullPath: '/workspaces/$workspaceId/screenata/integrations'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataIntegrationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/generate-policies': {
      id: '/(protected)/workspaces/$workspaceId/screenata/generate-policies'
      path: '/screenata/generate-policies'
      fullPath: '/workspaces/$workspaceId/screenata/generate-policies'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/evidence': {
      id: '/(protected)/workspaces/$workspaceId/screenata/evidence'
      path: '/screenata/evidence'
      fullPath: '/workspaces/$workspaceId/screenata/evidence'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataEvidenceRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/connect-repo': {
      id: '/(protected)/workspaces/$workspaceId/screenata/connect-repo'
      path: '/screenata/connect-repo'
      fullPath: '/workspaces/$workspaceId/screenata/connect-repo'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataConnectRepoRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/screenata/approvals': {
      id: '/(protected)/workspaces/$workspaceId/screenata/approvals'
      path: '/screenata/approvals'
      fullPath: '/workspaces/$workspaceId/screenata/approvals'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdScreenataApprovalsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/pulse/configure': {
      id: '/(protected)/workspaces/$workspaceId/pulse/configure'
      path: '/pulse/configure'
      fullPath: '/workspaces/$workspaceId/pulse/configure'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPulseConfigureRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/publish/files': {
      id: '/(protected)/workspaces/$workspaceId/publish/files'
      path: '/files'
      fullPath: '/workspaces/$workspaceId/publish/files'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPublishFilesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/generate/doc': {
      id: '/(protected)/workspaces/$workspaceId/generate/doc'
      path: '/generate/doc'
      fullPath: '/workspaces/$workspaceId/generate/doc'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdGenerateDocRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence/work-queue': {
      id: '/(protected)/workspaces/$workspaceId/evidence/work-queue'
      path: '/evidence/work-queue'
      fullPath: '/workspaces/$workspaceId/evidence/work-queue'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceWorkQueueRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence/review-queue': {
      id: '/(protected)/workspaces/$workspaceId/evidence/review-queue'
      path: '/evidence/review-queue'
      fullPath: '/workspaces/$workspaceId/evidence/review-queue'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceReviewQueueRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence/creating': {
      id: '/(protected)/workspaces/$workspaceId/evidence/creating'
      path: '/evidence/creating'
      fullPath: '/workspaces/$workspaceId/evidence/creating'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence/$evidenceId': {
      id: '/(protected)/workspaces/$workspaceId/evidence/$evidenceId'
      path: '/evidence/$evidenceId'
      fullPath: '/workspaces/$workspaceId/evidence/$evidenceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId': {
      id: '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
      path: '/evidence-viewer/$evidencePackId'
      fullPath: '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/docs/$': {
      id: '/(protected)/workspaces/$workspaceId/docs/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/docs/$'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDocsSplatRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdDocsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/automation/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/automation/'
      path: '/automation'
      fullPath: '/workspaces/$workspaceId/compliance/automation/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/': {
      id: '/(protected)/workspaces/$workspaceId/change-requests/$changeRequestId/'
      path: '/change-requests/$changeRequestId'
      fullPath: '/workspaces/$workspaceId/change-requests/$changeRequestId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/$templateId/': {
      id: '/(protected)/workspaces/$workspaceId/templates/$templateId/'
      path: '/templates/$templateId'
      fullPath: '/workspaces/$workspaceId/templates/$templateId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/steps/$id/': {
      id: '/(protected)/workspaces/$workspaceId/steps/$id/'
      path: '/steps/$id'
      fullPath: '/workspaces/$workspaceId/steps/$id/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/$sopId/': {
      id: '/(protected)/workspaces/$workspaceId/sops/$sopId/'
      path: '/sops/$sopId'
      fullPath: '/workspaces/$workspaceId/sops/$sopId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/tasks/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/tasks/'
      path: '/tasks'
      fullPath: '/workspaces/$workspaceId/compliance/tasks/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceTasksIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/setup/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/setup/'
      path: '/setup'
      fullPath: '/workspaces/$workspaceId/compliance/setup/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceSetupIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/runs/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/runs/'
      path: '/runs'
      fullPath: '/workspaces/$workspaceId/compliance/runs/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceRunsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/populations/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/populations/'
      path: '/populations'
      fullPath: '/workspaces/$workspaceId/compliance/populations/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/policies/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/policies/'
      path: '/policies'
      fullPath: '/workspaces/$workspaceId/compliance/policies/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/'
      path: '/$frameworkId'
      fullPath: '/workspaces/$workspaceId/compliance/$frameworkId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/flows/$flowId/view': {
      id: '/(protected)/workspaces/$workspaceId/flows/$flowId/view'
      path: '/flows/$flowId/view'
      fullPath: '/workspaces/$workspaceId/flows/$flowId/view'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/automation/identities': {
      id: '/(protected)/workspaces/$workspaceId/compliance/automation/identities'
      path: '/automation/identities'
      fullPath: '/workspaces/$workspaceId/compliance/automation/identities'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/$templateId/edit': {
      id: '/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/workspaces/$workspaceId/templates/$templateId/edit'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/$sopId/generate': {
      id: '/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
      path: '/sops/$sopId/generate'
      fullPath: '/workspaces/$workspaceId/sops/$sopId/generate'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/tests/$testId': {
      id: '/(protected)/workspaces/$workspaceId/compliance/tests/$testId'
      path: '/tests/$testId'
      fullPath: '/workspaces/$workspaceId/compliance/tests/$testId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceTestsTestIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/submissions/$submissionId': {
      id: '/(protected)/workspaces/$workspaceId/compliance/submissions/$submissionId'
      path: '/submissions/$submissionId'
      fullPath: '/workspaces/$workspaceId/compliance/submissions/$submissionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/runs/$executionId': {
      id: '/(protected)/workspaces/$workspaceId/compliance/runs/$executionId'
      path: '/runs/$executionId'
      fullPath: '/workspaces/$workspaceId/compliance/runs/$executionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/control/$controlId/': {
      id: '/(protected)/workspaces/$workspaceId/templates/control/$controlId/'
      path: '/templates/control/$controlId'
      fullPath: '/workspaces/$workspaceId/templates/control/$controlId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/automation/$executionId/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/automation/$executionId/'
      path: '/automation/$executionId'
      fullPath: '/workspaces/$workspaceId/compliance/automation/$executionId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/controls/': {
      id: '/(protected)/workspaces/$workspaceId/compliance/$frameworkId/controls/'
      path: '/$frameworkId/controls'
      fullPath: '/workspaces/$workspaceId/compliance/$frameworkId/controls/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId': {
      id: '/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'
      path: '/workflows/$workflowId/executions/$jobId'
      fullPath: '/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authAcceptInvitationRoute: typeof authAcceptInvitationRoute
  authInviteRoute: typeof authInviteRoute
  authLoginRoute: typeof authLoginRoute
  authLogoutRoute: typeof authLogoutRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authShareInviteRoute: typeof authShareInviteRoute
  authSopShareInviteRoute: typeof authSopShareInviteRoute
  authSopShareVerifyOtpRoute: typeof authSopShareVerifyOtpRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authLogin2LazyRoute: typeof authLogin2LazyRoute
  authSignupLazyRoute: typeof authSignupLazyRoute
  authVerify2faLazyRoute: typeof authVerify2faLazyRoute
  authVerifyOtpLazyRoute: typeof authVerifyOtpLazyRoute
  authAuthCallbackProviderRoute: typeof authAuthCallbackProviderRoute
  authNativeAuthCallbackRoute: typeof authNativeAuthCallbackRoute
  authNativeLoginRoute: typeof authNativeLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authAcceptInvitationRoute: authAcceptInvitationRoute,
  authInviteRoute: authInviteRoute,
  authLoginRoute: authLoginRoute,
  authLogoutRoute: authLogoutRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authShareInviteRoute: authShareInviteRoute,
  authSopShareInviteRoute: authSopShareInviteRoute,
  authSopShareVerifyOtpRoute: authSopShareVerifyOtpRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authLogin2LazyRoute: authLogin2LazyRoute,
  authSignupLazyRoute: authSignupLazyRoute,
  authVerify2faLazyRoute: authVerify2faLazyRoute,
  authVerifyOtpLazyRoute: authVerifyOtpLazyRoute,
  authAuthCallbackProviderRoute: authAuthCallbackProviderRoute,
  authNativeAuthCallbackRoute: authNativeAuthCallbackRoute,
  authNativeLoginRoute: authNativeLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedOrgsRouteRouteChildren {
  protectedOrgsSlugRouteRoute: typeof protectedOrgsSlugRouteRoute
  protectedOrgsIndexLazyRoute: typeof protectedOrgsIndexLazyRoute
}

const protectedOrgsRouteRouteChildren: protectedOrgsRouteRouteChildren = {
  protectedOrgsSlugRouteRoute: protectedOrgsSlugRouteRoute,
  protectedOrgsIndexLazyRoute: protectedOrgsIndexLazyRoute,
}

const protectedOrgsRouteRouteWithChildren =
  protectedOrgsRouteRoute._addFileChildren(protectedOrgsRouteRouteChildren)

interface protectedPartnerRouteRouteChildren {
  protectedPartnerTemplatesRoute: typeof protectedPartnerTemplatesRoute
  protectedPartnerIndexRoute: typeof protectedPartnerIndexRoute
  protectedPartnerClientsClientIdRoute: typeof protectedPartnerClientsClientIdRoute
  protectedPartnerClientsNewRoute: typeof protectedPartnerClientsNewRoute
}

const protectedPartnerRouteRouteChildren: protectedPartnerRouteRouteChildren = {
  protectedPartnerTemplatesRoute: protectedPartnerTemplatesRoute,
  protectedPartnerIndexRoute: protectedPartnerIndexRoute,
  protectedPartnerClientsClientIdRoute: protectedPartnerClientsClientIdRoute,
  protectedPartnerClientsNewRoute: protectedPartnerClientsNewRoute,
}

const protectedPartnerRouteRouteWithChildren =
  protectedPartnerRouteRoute._addFileChildren(
    protectedPartnerRouteRouteChildren,
  )

interface protectedSettingsRouteRouteChildren {
  protectedSettingsApiKeysRoute: typeof protectedSettingsApiKeysRoute
  protectedSettingsAuditLogsRoute: typeof protectedSettingsAuditLogsRoute
  protectedSettingsAuthRoute: typeof protectedSettingsAuthRoute
  protectedSettingsBillingRoute: typeof protectedSettingsBillingRoute
  protectedSettingsBrandingRoute: typeof protectedSettingsBrandingRoute
  protectedSettingsChatRoute: typeof protectedSettingsChatRoute
  protectedSettingsChecksRoute: typeof protectedSettingsChecksRoute
  protectedSettingsComplianceRoute: typeof protectedSettingsComplianceRoute
  protectedSettingsConfigurationRoute: typeof protectedSettingsConfigurationRoute
  protectedSettingsGeneralRoute: typeof protectedSettingsGeneralRoute
  protectedSettingsMcpServerRoute: typeof protectedSettingsMcpServerRoute
  protectedSettingsMembersRoute: typeof protectedSettingsMembersRoute
  protectedSettingsOrganizationRoute: typeof protectedSettingsOrganizationRoute
  protectedSettingsPersonasRoute: typeof protectedSettingsPersonasRoute
  protectedSettingsProfileRoute: typeof protectedSettingsProfileRoute
  protectedSettingsPropertiesRoute: typeof protectedSettingsPropertiesRoute
  protectedSettingsPublishingRoute: typeof protectedSettingsPublishingRoute
  protectedSettingsReviewRoute: typeof protectedSettingsReviewRoute
  protectedSettingsSecurityRoute: typeof protectedSettingsSecurityRoute
  protectedSettingsSigningRoute: typeof protectedSettingsSigningRoute
  protectedSettingsTemplatesRoute: typeof protectedSettingsTemplatesRoute
  protectedSettingsThemeRoute: typeof protectedSettingsThemeRoute
  protectedSettingsWritingRoute: typeof protectedSettingsWritingRoute
  protectedSettingsIndexRoute: typeof protectedSettingsIndexRoute
  protectedSettingsServiceAccountsIndexRoute: typeof protectedSettingsServiceAccountsIndexRoute
}

const protectedSettingsRouteRouteChildren: protectedSettingsRouteRouteChildren =
  {
    protectedSettingsApiKeysRoute: protectedSettingsApiKeysRoute,
    protectedSettingsAuditLogsRoute: protectedSettingsAuditLogsRoute,
    protectedSettingsAuthRoute: protectedSettingsAuthRoute,
    protectedSettingsBillingRoute: protectedSettingsBillingRoute,
    protectedSettingsBrandingRoute: protectedSettingsBrandingRoute,
    protectedSettingsChatRoute: protectedSettingsChatRoute,
    protectedSettingsChecksRoute: protectedSettingsChecksRoute,
    protectedSettingsComplianceRoute: protectedSettingsComplianceRoute,
    protectedSettingsConfigurationRoute: protectedSettingsConfigurationRoute,
    protectedSettingsGeneralRoute: protectedSettingsGeneralRoute,
    protectedSettingsMcpServerRoute: protectedSettingsMcpServerRoute,
    protectedSettingsMembersRoute: protectedSettingsMembersRoute,
    protectedSettingsOrganizationRoute: protectedSettingsOrganizationRoute,
    protectedSettingsPersonasRoute: protectedSettingsPersonasRoute,
    protectedSettingsProfileRoute: protectedSettingsProfileRoute,
    protectedSettingsPropertiesRoute: protectedSettingsPropertiesRoute,
    protectedSettingsPublishingRoute: protectedSettingsPublishingRoute,
    protectedSettingsReviewRoute: protectedSettingsReviewRoute,
    protectedSettingsSecurityRoute: protectedSettingsSecurityRoute,
    protectedSettingsSigningRoute: protectedSettingsSigningRoute,
    protectedSettingsTemplatesRoute: protectedSettingsTemplatesRoute,
    protectedSettingsThemeRoute: protectedSettingsThemeRoute,
    protectedSettingsWritingRoute: protectedSettingsWritingRoute,
    protectedSettingsIndexRoute: protectedSettingsIndexRoute,
    protectedSettingsServiceAccountsIndexRoute:
      protectedSettingsServiceAccountsIndexRoute,
  }

const protectedSettingsRouteRouteWithChildren =
  protectedSettingsRouteRoute._addFileChildren(
    protectedSettingsRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdComplianceRouteRouteChildren {
  protectedWorkspacesWorkspaceIdComplianceIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceIndexRoute
  protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute: typeof protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute
  protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute: typeof protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute
  protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute: typeof protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute
  protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute
  protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute
  protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute: typeof protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute
  protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute: typeof protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute
  protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute
  protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute
  protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute
  protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute
  protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute
  protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute: typeof protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute
}

const protectedWorkspacesWorkspaceIdComplianceRouteRouteChildren: protectedWorkspacesWorkspaceIdComplianceRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdComplianceIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute:
      protectedWorkspacesWorkspaceIdComplianceRunsExecutionIdRoute,
    protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute:
      protectedWorkspacesWorkspaceIdComplianceSubmissionsSubmissionIdRoute,
    protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute:
      protectedWorkspacesWorkspaceIdComplianceTestsTestIdRoute,
    protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute:
      protectedWorkspacesWorkspaceIdComplianceAutomationIdentitiesLazyRoute,
    protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceFrameworkIdIndexRoute,
    protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute:
      protectedWorkspacesWorkspaceIdCompliancePoliciesIndexRoute,
    protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute:
      protectedWorkspacesWorkspaceIdCompliancePopulationsIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceRunsIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceSetupIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceTasksIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute:
      protectedWorkspacesWorkspaceIdComplianceAutomationIndexLazyRoute,
    protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceFrameworkIdControlsIndexRoute,
    protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute:
      protectedWorkspacesWorkspaceIdComplianceAutomationExecutionIdIndexRoute,
  }

const protectedWorkspacesWorkspaceIdComplianceRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdComplianceRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdComplianceRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdDocsRouteRouteChildren {
  protectedWorkspacesWorkspaceIdDocsSplatRoute: typeof protectedWorkspacesWorkspaceIdDocsSplatRoute
}

const protectedWorkspacesWorkspaceIdDocsRouteRouteChildren: protectedWorkspacesWorkspaceIdDocsRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdDocsSplatRoute:
      protectedWorkspacesWorkspaceIdDocsSplatRoute,
  }

const protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdDocsRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdDocsRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdPublishRouteRouteChildren {
  protectedWorkspacesWorkspaceIdPublishFilesRoute: typeof protectedWorkspacesWorkspaceIdPublishFilesRoute
  protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute: typeof protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute
  protectedWorkspacesWorkspaceIdPublishStageLazyRoute: typeof protectedWorkspacesWorkspaceIdPublishStageLazyRoute
  protectedWorkspacesWorkspaceIdPublishIndexRoute: typeof protectedWorkspacesWorkspaceIdPublishIndexRoute
}

const protectedWorkspacesWorkspaceIdPublishRouteRouteChildren: protectedWorkspacesWorkspaceIdPublishRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdPublishFilesRoute:
      protectedWorkspacesWorkspaceIdPublishFilesRoute,
    protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute:
      protectedWorkspacesWorkspaceIdPublishDeploymentsLazyRoute,
    protectedWorkspacesWorkspaceIdPublishStageLazyRoute:
      protectedWorkspacesWorkspaceIdPublishStageLazyRoute,
    protectedWorkspacesWorkspaceIdPublishIndexRoute:
      protectedWorkspacesWorkspaceIdPublishIndexRoute,
  }

const protectedWorkspacesWorkspaceIdPublishRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdPublishRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdPublishRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdRouteRouteChildren {
  protectedWorkspacesWorkspaceIdComplianceRouteRoute: typeof protectedWorkspacesWorkspaceIdComplianceRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdDocsRouteRoute: typeof protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdImportRouteRoute: typeof protectedWorkspacesWorkspaceIdImportRouteRoute
  protectedWorkspacesWorkspaceIdPublishRouteRoute: typeof protectedWorkspacesWorkspaceIdPublishRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdAnalyticsRoute: typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  protectedWorkspacesWorkspaceIdEditRoute: typeof protectedWorkspacesWorkspaceIdEditRoute
  protectedWorkspacesWorkspaceIdReviewTopicsRoute: typeof protectedWorkspacesWorkspaceIdReviewTopicsRoute
  protectedWorkspacesWorkspaceIdSummaryRoute: typeof protectedWorkspacesWorkspaceIdSummaryRoute
  protectedWorkspacesWorkspaceIdVideoProcessingRoute: typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute: typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  protectedWorkspacesWorkspaceIdGitSettingsLazyRoute: typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  protectedWorkspacesWorkspaceIdIndexRoute: typeof protectedWorkspacesWorkspaceIdIndexRoute
  protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute: typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute: typeof protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute
  protectedWorkspacesWorkspaceIdEvidenceCreatingRoute: typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute: typeof protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute
  protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute: typeof protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute
  protectedWorkspacesWorkspaceIdGenerateDocRoute: typeof protectedWorkspacesWorkspaceIdGenerateDocRoute
  protectedWorkspacesWorkspaceIdPulseConfigureRoute: typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  protectedWorkspacesWorkspaceIdScreenataApprovalsRoute: typeof protectedWorkspacesWorkspaceIdScreenataApprovalsRoute
  protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute: typeof protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute
  protectedWorkspacesWorkspaceIdScreenataEvidenceRoute: typeof protectedWorkspacesWorkspaceIdScreenataEvidenceRoute
  protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute: typeof protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute
  protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute: typeof protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute
  protectedWorkspacesWorkspaceIdScreenataPoliciesRoute: typeof protectedWorkspacesWorkspaceIdScreenataPoliciesRoute
  protectedWorkspacesWorkspaceIdScreenataReadinessRoute: typeof protectedWorkspacesWorkspaceIdScreenataReadinessRoute
  protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute: typeof protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute
  protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute: typeof protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute
  protectedWorkspacesWorkspaceIdScreenataTestsRoute: typeof protectedWorkspacesWorkspaceIdScreenataTestsRoute
  protectedWorkspacesWorkspaceIdTasksTaskIdRoute: typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  protectedWorkspacesWorkspaceIdTemplatesNewRoute: typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  protectedWorkspacesWorkspaceIdTemplatesPublicRoute: typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  protectedWorkspacesWorkspaceIdDashboardIndexRoute: typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  protectedWorkspacesWorkspaceIdEvidenceIndexRoute: typeof protectedWorkspacesWorkspaceIdEvidenceIndexRoute
  protectedWorkspacesWorkspaceIdGlossaryIndexRoute: typeof protectedWorkspacesWorkspaceIdGlossaryIndexRoute
  protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute: typeof protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute
  protectedWorkspacesWorkspaceIdPulseIndexRoute: typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  protectedWorkspacesWorkspaceIdScreenataIndexRoute: typeof protectedWorkspacesWorkspaceIdScreenataIndexRoute
  protectedWorkspacesWorkspaceIdSopsIndexRoute: typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  protectedWorkspacesWorkspaceIdSourcesIndexRoute: typeof protectedWorkspacesWorkspaceIdSourcesIndexRoute
  protectedWorkspacesWorkspaceIdTasksIndexRoute: typeof protectedWorkspacesWorkspaceIdTasksIndexRoute
  protectedWorkspacesWorkspaceIdTemplatesIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute
  protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute
  protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  protectedWorkspacesWorkspaceIdStepsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute: typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  protectedWorkspacesWorkspaceIdStepsIdIndexRoute: typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute
  protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute: typeof protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute
  protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
}

const protectedWorkspacesWorkspaceIdRouteRouteChildren: protectedWorkspacesWorkspaceIdRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdComplianceRouteRoute:
      protectedWorkspacesWorkspaceIdComplianceRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdDocsRouteRoute:
      protectedWorkspacesWorkspaceIdDocsRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdImportRouteRoute:
      protectedWorkspacesWorkspaceIdImportRouteRoute,
    protectedWorkspacesWorkspaceIdPublishRouteRoute:
      protectedWorkspacesWorkspaceIdPublishRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdAnalyticsRoute:
      protectedWorkspacesWorkspaceIdAnalyticsRoute,
    protectedWorkspacesWorkspaceIdEditRoute:
      protectedWorkspacesWorkspaceIdEditRoute,
    protectedWorkspacesWorkspaceIdReviewTopicsRoute:
      protectedWorkspacesWorkspaceIdReviewTopicsRoute,
    protectedWorkspacesWorkspaceIdSummaryRoute:
      protectedWorkspacesWorkspaceIdSummaryRoute,
    protectedWorkspacesWorkspaceIdVideoProcessingRoute:
      protectedWorkspacesWorkspaceIdVideoProcessingRoute,
    protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute:
      protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute,
    protectedWorkspacesWorkspaceIdGitSettingsLazyRoute:
      protectedWorkspacesWorkspaceIdGitSettingsLazyRoute,
    protectedWorkspacesWorkspaceIdIndexRoute:
      protectedWorkspacesWorkspaceIdIndexRoute,
    protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute:
      protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute,
    protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute:
      protectedWorkspacesWorkspaceIdEvidenceEvidenceIdRoute,
    protectedWorkspacesWorkspaceIdEvidenceCreatingRoute:
      protectedWorkspacesWorkspaceIdEvidenceCreatingRoute,
    protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute:
      protectedWorkspacesWorkspaceIdEvidenceReviewQueueRoute,
    protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute:
      protectedWorkspacesWorkspaceIdEvidenceWorkQueueRoute,
    protectedWorkspacesWorkspaceIdGenerateDocRoute:
      protectedWorkspacesWorkspaceIdGenerateDocRoute,
    protectedWorkspacesWorkspaceIdPulseConfigureRoute:
      protectedWorkspacesWorkspaceIdPulseConfigureRoute,
    protectedWorkspacesWorkspaceIdScreenataApprovalsRoute:
      protectedWorkspacesWorkspaceIdScreenataApprovalsRoute,
    protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute:
      protectedWorkspacesWorkspaceIdScreenataConnectRepoRoute,
    protectedWorkspacesWorkspaceIdScreenataEvidenceRoute:
      protectedWorkspacesWorkspaceIdScreenataEvidenceRoute,
    protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute:
      protectedWorkspacesWorkspaceIdScreenataGeneratePoliciesRoute,
    protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute:
      protectedWorkspacesWorkspaceIdScreenataIntegrationsRoute,
    protectedWorkspacesWorkspaceIdScreenataPoliciesRoute:
      protectedWorkspacesWorkspaceIdScreenataPoliciesRoute,
    protectedWorkspacesWorkspaceIdScreenataReadinessRoute:
      protectedWorkspacesWorkspaceIdScreenataReadinessRoute,
    protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute:
      protectedWorkspacesWorkspaceIdScreenataScopeConfirmRoute,
    protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute:
      protectedWorkspacesWorkspaceIdScreenataTestOutlineRoute,
    protectedWorkspacesWorkspaceIdScreenataTestsRoute:
      protectedWorkspacesWorkspaceIdScreenataTestsRoute,
    protectedWorkspacesWorkspaceIdTasksTaskIdRoute:
      protectedWorkspacesWorkspaceIdTasksTaskIdRoute,
    protectedWorkspacesWorkspaceIdTemplatesNewRoute:
      protectedWorkspacesWorkspaceIdTemplatesNewRoute,
    protectedWorkspacesWorkspaceIdTemplatesPublicRoute:
      protectedWorkspacesWorkspaceIdTemplatesPublicRoute,
    protectedWorkspacesWorkspaceIdDashboardIndexRoute:
      protectedWorkspacesWorkspaceIdDashboardIndexRoute,
    protectedWorkspacesWorkspaceIdEvidenceIndexRoute:
      protectedWorkspacesWorkspaceIdEvidenceIndexRoute,
    protectedWorkspacesWorkspaceIdGlossaryIndexRoute:
      protectedWorkspacesWorkspaceIdGlossaryIndexRoute,
    protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute:
      protectedWorkspacesWorkspaceIdKnowledgeGapsIndexRoute,
    protectedWorkspacesWorkspaceIdPulseIndexRoute:
      protectedWorkspacesWorkspaceIdPulseIndexRoute,
    protectedWorkspacesWorkspaceIdScreenataIndexRoute:
      protectedWorkspacesWorkspaceIdScreenataIndexRoute,
    protectedWorkspacesWorkspaceIdSopsIndexRoute:
      protectedWorkspacesWorkspaceIdSopsIndexRoute,
    protectedWorkspacesWorkspaceIdSourcesIndexRoute:
      protectedWorkspacesWorkspaceIdSourcesIndexRoute,
    protectedWorkspacesWorkspaceIdTasksIndexRoute:
      protectedWorkspacesWorkspaceIdTasksIndexRoute,
    protectedWorkspacesWorkspaceIdTemplatesIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesIndexRoute,
    protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute:
      protectedWorkspacesWorkspaceIdBranchesIndexLazyRoute,
    protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdChangeRequestsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdStepsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdStepsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute:
      protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute,
    protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute:
      protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute,
    protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute:
      protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute,
    protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute:
      protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute,
    protectedWorkspacesWorkspaceIdStepsIdIndexRoute:
      protectedWorkspacesWorkspaceIdStepsIdIndexRoute,
    protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute,
    protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute:
      protectedWorkspacesWorkspaceIdChangeRequestsChangeRequestIdIndexLazyRoute,
    protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute:
      protectedWorkspacesWorkspaceIdWorkflowsWorkflowIdExecutionsJobIdRoute,
    protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute,
  }

const protectedWorkspacesWorkspaceIdRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdRouteRouteChildren,
  )

interface protectedWorkspacesRouteRouteChildren {
  protectedWorkspacesWorkspaceIdRouteRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  protectedWorkspacesNewRoute: typeof protectedWorkspacesNewRoute
  protectedWorkspacesIndexLazyRoute: typeof protectedWorkspacesIndexLazyRoute
}

const protectedWorkspacesRouteRouteChildren: protectedWorkspacesRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdRouteRoute:
      protectedWorkspacesWorkspaceIdRouteRouteWithChildren,
    protectedWorkspacesNewRoute: protectedWorkspacesNewRoute,
    protectedWorkspacesIndexLazyRoute: protectedWorkspacesIndexLazyRoute,
  }

const protectedWorkspacesRouteRouteWithChildren =
  protectedWorkspacesRouteRoute._addFileChildren(
    protectedWorkspacesRouteRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedOrgsRouteRoute: typeof protectedOrgsRouteRouteWithChildren
  protectedPartnerRouteRoute: typeof protectedPartnerRouteRouteWithChildren
  protectedSettingsRouteRoute: typeof protectedSettingsRouteRouteWithChildren
  protectedWorkspacesRouteRoute: typeof protectedWorkspacesRouteRouteWithChildren
  protectedIndexRoute: typeof protectedIndexRoute
  protectedDevPlanRestrictionsTestRoute: typeof protectedDevPlanRestrictionsTestRoute
  protectedTasksIndexRoute: typeof protectedTasksIndexRoute
  protectedIntegrationsIndexLazyRoute: typeof protectedIntegrationsIndexLazyRoute
  protectedOnboardingIndexLazyRoute: typeof protectedOnboardingIndexLazyRoute
  protectedTeamIndexLazyRoute: typeof protectedTeamIndexLazyRoute
  protectedWorkspaceIntegrationsGithubRoute: typeof protectedWorkspaceIntegrationsGithubRoute
  protectedOnboardingOrganizationIdWorkspaceLazyRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  protectedWorkspaceIntegrationsIndexRoute: typeof protectedWorkspaceIntegrationsIndexRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedOrgsRouteRoute: protectedOrgsRouteRouteWithChildren,
  protectedPartnerRouteRoute: protectedPartnerRouteRouteWithChildren,
  protectedSettingsRouteRoute: protectedSettingsRouteRouteWithChildren,
  protectedWorkspacesRouteRoute: protectedWorkspacesRouteRouteWithChildren,
  protectedIndexRoute: protectedIndexRoute,
  protectedDevPlanRestrictionsTestRoute: protectedDevPlanRestrictionsTestRoute,
  protectedTasksIndexRoute: protectedTasksIndexRoute,
  protectedIntegrationsIndexLazyRoute: protectedIntegrationsIndexLazyRoute,
  protectedOnboardingIndexLazyRoute: protectedOnboardingIndexLazyRoute,
  protectedTeamIndexLazyRoute: protectedTeamIndexLazyRoute,
  protectedWorkspaceIntegrationsGithubRoute:
    protectedWorkspaceIntegrationsGithubRoute,
  protectedOnboardingOrganizationIdWorkspaceLazyRoute:
    protectedOnboardingOrganizationIdWorkspaceLazyRoute,
  protectedWorkspaceIntegrationsIndexRoute:
    protectedWorkspaceIntegrationsIndexRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
  ExtensionUninstalledLazyRoute: ExtensionUninstalledLazyRoute,
  DemoPulseRoute: DemoPulseRoute,
  IntegrationsGithubAppCallbackRoute: IntegrationsGithubAppCallbackRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  SharedSopShareIdLazyRoute: SharedSopShareIdLazyRoute,
  SharedShareIdLazyRoute: SharedShareIdLazyRoute,
  DemoTiptapAiChangesRoute: DemoTiptapAiChangesRoute,
  DemoTiptapAiSuggestionRoute: DemoTiptapAiSuggestionRoute,
  SharedTestShareTokenLazyRoute: SharedTestShareTokenLazyRoute,
  DemoTiptapIndexRoute: DemoTiptapIndexRoute,
  EvidenceVerifyIndexRoute: EvidenceVerifyIndexRoute,
  ExportSopEmbedIndexRoute: ExportSopEmbedIndexRoute,
  ExportSopPdfIndexRoute: ExportSopPdfIndexRoute,
  ExportTopicEmbedIndexRoute: ExportTopicEmbedIndexRoute,
  ExportTopicPdfIndexRoute: ExportTopicPdfIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
